/* ============================================================================
   PrimeStyle collection-page shell — SHARED BEHAVIOUR
   ----------------------------------------------------------------------------
   Filtering, sorting, the product grid, editorial/creative tiles, Favorite
   Picks, Drive image hydration, metal swatches, compare and the pager. Every
   collection page loads this file; none of them owns a copy of it.

   A page supplies two globals before this script runs:
     window.PS_COLLECTION  — assets/data/products.js (the pipeline's output)
     window.PS_PAGE        — this page's config (see DEFAULTS below)

   Change behaviour here once and every collection page changes with it. That is
   the point: twelve hand-maintained copies is how pages drift apart.
   ========================================================================== */
function psCol26Boot(){
  'use strict';

  /* Boot exactly once. The sections are swept and the port gate now blocks a
     duplicated loader, but this is the line that protects live customers if a
     Shopify app or a template ever loads the shell twice anyway: the second run
     found 2026-08-27 doubled every product on the first Load More click. */
  if (window.__psCol26Shell) return;
  window.__psCol26Shell = true;

  var CFG = window.PS_PAGE || {};
  var DATA = (window.PS_COLLECTION && window.PS_COLLECTION.products) ? window.PS_COLLECTION : {collection:{count:0},products:[]};
  /* A frozen data-products.js snapshot is in USD; the live Liquid feed says its currency.
     Convert a snapshot once, in place, so every price below (cards, filters, compare,
     the hub scripts that read the same objects) is in the shopper's currency. */
  if (window.PSMoney) PSMoney.normalize(DATA);
  var PRODUCTS = DATA.products;
  var COLLECTION = DATA.collection;
  /* Owner review 2026-09-10 (C-10): a shape page shows ONLY that shape. The store's
     round-bracelets collection carries ten princess tennis bracelets (its rule is wider
     than its name), so a section may lock the shelf to one center shape and every
     other product is dropped before the shell sees it, on the first page and on merge. */
  var SHAPE_LOCK = String(CFG.shapeLock || '').toLowerCase();
  /* originLock ('natural' | 'lab'): the Diamond Rings facets (By Shape, By Budget, By
     Total Carat) are natural pages, the Lab Grown menu has its own; the 2026 facet
     collections were built from shape / price / carat signals alone (2026-08-25). */
  var ORIGIN_LOCK = String(CFG.originLock || '').toLowerCase();
  function locked(p){
    if (!p) return false;
    /* A product CARRYING the locked shape passes, not only one whose display shape is it:
       a "Princess & Round" bracelet (shapes [princess, round], shape princess) belongs on
       the round page it was placed in. The exact-shape test dropped the curated pick 71800
       there and 110420 on the princess rings page, and a best seller's white render took
       the pick's place (owner video 2026-09-19). */
    if (SHAPE_LOCK && SHAPE_LOCK !== '*' && p.shape !== SHAPE_LOCK && !(p.shapes && p.shapes.indexOf(SHAPE_LOCK) > -1)) return false;
    if (ORIGIN_LOCK && (p.origin || 'natural') !== ORIGIN_LOCK) return false;
    return true;
  }
  if (ORIGIN_LOCK && !SHAPE_LOCK) SHAPE_LOCK = '*';   /* reuse the lock plumbing below */
  /* Products the ORIGIN lock alone kept off the grid (their shape passes). The curated
     Favorite Picks may still name them: the heart page pins 71834 / 71834lb / 71834bl /
     71834pk to fill its row of six from two natural designs, the oval page pins lab-only
     designs (21012lb, 21103lbov). Owner video 2026-09-19: those rows must show the picks'
     worn shots again, so the picks resolve against this list too (grid and filters never
     see it). */
  var LOCKED_OUT = [];
  function originOnly(p){
    return !!p && !!ORIGIN_LOCK && (p.origin || 'natural') !== ORIGIN_LOCK
      && !(SHAPE_LOCK && SHAPE_LOCK !== '*' && p.shape !== SHAPE_LOCK && !(p.shapes && p.shapes.indexOf(SHAPE_LOCK) > -1));
  }
  if (SHAPE_LOCK) {
    DATA.products.forEach(function(p){ if (originOnly(p)) LOCKED_OUT.push(p); });
    DATA.products = DATA.products.filter(locked);
    PRODUCTS = DATA.products;
    /* the true count is only known once every feed page is in (see feedReady below);
       a one-page collection settles it here */
    if (COLLECTION && !(DATA.complete && typeof DATA.complete.then === 'function')) COLLECTION.count = PRODUCTS.length;
  }
  /* Every product the filters see carries valid keys or none (approved filter drawer,
     2026-09-07): an unknown shape or origin string is dropped rather than rendered as a
     control, and `metals` is validated into {key:[price, compareAt|null]}. */
  if (window.PSFilterCore) { PRODUCTS.forEach(window.PSFilterCore.normalizeProduct); LOCKED_OUT.forEach(window.PSFilterCore.normalizeProduct); }
  /* Set by the 2026 filter drawer when its markup is on the page; the shell calls it
     after every re-render so chips and the URL follow sort changes too. */
  var FILTERS26 = null;

  /* ---- config with defaults ---- */
  var DS = CFG.ds || '../_ds';
  /* Shopify port: the section defines window.PS_PORT = {base:<cdn assets dir>, prefix:'ps-<abbrev>-'}.
     Page assets flatten (subdir slash -> dash) onto the CDN; _ds icons live there as ps-26-<name>. */
  var PORT = window.PS_PORT || null;
  function pageAsset(rel) {
    if (!PORT) return 'assets/' + rel;
    /* Theme assets fetched by composed name carry no ?v=, and the CDN caches them for a
       YEAR (cache-control max-age=31557600), so a re-shot pick never reached the page:
       the wedding-sets row kept showing its first-generation stacked pairs after the
       one-ring-per-hand re-shoot (owner, 2026-09-04). PS_PORT.v is a per-page stamp the
       section bumps whenever its lifestyle files change. */
    var u = PORT.base + PORT.prefix + rel.replace(/\//g, '-');
    return PORT.v ? u + '?v=' + PORT.v : u;
  }
  function dsAsset(name) { return PORT ? PORT.base + 'ps-26-' + name : DS + '/assets/' + name; }
  var NOUN = CFG.noun || 'pieces';
  var CARD_MODE = CFG.cardMode || 'jewelry';           /* 'jewelry' | 'stone' */
  /* The approved 2026 card (owner picked Version 1 on 2026-09-07 and asked for the
     finishing pass): one bordered card, name + spec + price in a tinted panel, a bottom
     rail of metal swatches and one compact rating, no shape row and no origin badge.
     OPT-IN per page — a section sets `cards26: true` — because the rollout was approved
     for engagement rings first and the rest of the collections (and the search page,
     which shares this shell) keep their current card until he says go. Turning it on
     elsewhere is one flag in that section. */
  var CARDS26 = !!CFG.cards26;
  /* A card VARIANT for a family whose product is a different shape on the page. Bracelets
     are wide, so they get three roomier columns, 4:3 frames that contain the whole piece,
     and a manual favorites shelf (owner-approved 2026-09-07). Declared explicitly per
     section — never inferred from a product title, so no other collection moves. */
  var CARDS_VARIANT = CFG.cardsVariant || '';
  if (CARDS26) {
    var mainEl = document.querySelector('main');
    if (mainEl) {
      mainEl.classList.add('cards26');
      if (CARDS_VARIANT) mainEl.classList.add('cards26--' + CARDS_VARIANT);
    }
  }
  /* Metal changes are visual only, so assistive tech needs to be told. One shared live
     region rather than a visible row on every card. */
  var liveMsg = null;
  /* The heart used to fill in and do nothing else: no save, no header count, and
     the shortlist was gone on the next visit. These are the calls the product page
     already makes; the difference is that a card now knows which variant it means. */
  function wishMetalKey(card){
    var sel = card.querySelector('.mdot.is-sel');
    var t = sel ? (sel.getAttribute('title') || '') : '';
    t = t.toLowerCase();
    if (/platinum/.test(t)) return 'platinum';
    if (/yellow/.test(t)) return 'yellow';
    if (/rose|pink/.test(t)) return 'rose';
    if (/white/.test(t)) return 'white';
    return null;
  }
  function wishIdsFor(card){
    var id = card.getAttribute('data-id');
    var p = id && P_BY_ID ? P_BY_ID[id] : null;
    if (!p) return null;
    var key = wishMetalKey(card);
    var vid = (key && p.vids && p.vids[key]) || p.vid;
    if (!vid) return null;
    return { variantId: String(vid), productId: String(p.id) };
  }
  function wishToggle(btn){
    var card = btn.closest('.pcard');
    var W = window.iWish;
    var ids = card ? wishIdsFor(card) : null;
    if (!W || typeof W.iwishAdd !== 'function' || !ids) {
      announce('The wishlist is still loading. Please try again in a moment.');
      return;
    }
    var on = false;
    try {
      if (W.isInWishlist(ids.variantId)) { W.iwishRemove(ids.variantId, ids.productId); }
      else { W.iwishAdd(ids.variantId, ids.productId, 1); on = true; }
      if (typeof W.setCounter === 'function') W.setCounter();
      if (window.changeDetect) window.changeDetect.status = on ? 'added' : 'removed';
    } catch (err) {
      announce('Could not update the wishlist.');
      return;   /* the heart does not fill in when the save did not happen */
    }
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', String(on));
    announce(on ? 'Saved to your wishlist.' : 'Removed from your wishlist.');
  }
  /* after any re-render, show what is actually saved */
  function wishSync(){
    var W = window.iWish;
    if (!W || typeof W.isInWishlist !== 'function') return;
    document.querySelectorAll('.pcard').forEach(function(card){
      var btn = card.querySelector('.pcard-wish');
      if (!btn) return;
      var ids = wishIdsFor(card);
      if (!ids) return;
      var on = false;
      try { on = !!W.isInWishlist(ids.variantId); } catch (e) { return; }
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
    });
  }

  function announce(text){
    if (!CARDS26) return;
    if (!liveMsg) {
      liveMsg = document.createElement('span');
      liveMsg.className = 'sr-h';
      liveMsg.setAttribute('role', 'status');
      liveMsg.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveMsg);
    }
    liveMsg.textContent = text;
  }
  var NAMING = CFG.naming || {};
  var NAME_FALLBACK = NAMING.fallback || '';
  var NAME_FAMILIES = NAMING.families || [];           /* [[/regex/ source, label], ...] */
  var PICK_METAL = (CFG.picks && CFG.picks.metal) || {};
  var PICK_LIFESTYLE = (CFG.picks && CFG.picks.lifestyle) || {};
  var TILE_EVERY = CFG.tileEvery || 16;
  var LIFESTYLE_TILES = CFG.tiles || [];
  /* Owner rule 2026-08-20 (video #234): a collection page carries the Design Your Own
     promo tile plus THREE model cards and no more — "it doesn't matter how many more
     items we have, the rest will be just showing the items". Without a cap the every-16
     cadence minted tiles forever, and every tile past the configured three fell through
     to the gray "Creative Slot 4 / 5 / 6…" scaffold deep in the grid, which is what he
     caught. Small collections need no special case: the boundaries never arrive. */
  /* 0 is a real value here (the search page carries no creative tiles), so the default
     applies only when the page says nothing. `|| 3` turned 0 into 3 and minted a grey
     "Creative Slot 1" scaffold in the middle of the search results (2026-09-03). */
  var MAX_TILES = (CFG.maxTiles == null) ? 3 : CFG.maxTiles;
  var MODEL_TILE = CFG.modelTile || {};
  var PROMO_TILE = CFG.promoTile || null;
  var CARD_SHAPES = CFG.shapeIcons || ['round', 'princess', 'emerald', 'oval', 'cushion'];
  var PREFER_CDN = !!CFG.preferCdn;                    /* color collections: live Shopify photo beats a colorless render (owner 2026-08-21) */
  /* ---- card positions (owner videos 2026-09-17 Product_Positioning_in_Collections and
     2026-09-19 Recording #258) ----
     A card shows POSITION 1 and reveals POSITION 2 on hover (a swipe on a phone), in the
     same metal. Which pose comes first is a PAGE decision keyed on the collection handle:
       laying-first    laying down STRAIGHT (stone facing the viewer, never the angled
                       laying), then standing ~15 degrees. Owner 2026-09-19: "one
                       consistent way for the entire website, for all the rings", so this
                       is every ring page (engagement, bridal, solitaire, halo, three-stone,
                       trio, wedding bands, wedding sets, eternity, men's, plain bands,
                       fashion, gemstone, colored, lab) and every mixed page (anniversary,
                       budget, carat, shape, metal, ready-to-ship); it is also the default.
                       The 2026-09-19 morning rule (bands / eternity / men's / trio opening
                       on the zoomed standing view) is withdrawn by the same owner.
       chain-first     the pendant on its chain, then the pendant alone.
       order           the product's first image, then its next one: bracelets (tennis
                       included, owner 2026-09-17), earrings, search.
     A section may pin `positions:` in PS_PAGE (`standing-first` stays available for that).
     The poses themselves come from the feed's `images.views` (metafield ps26.card_views,
     tools/product-images/write_card_views.py; our renders are labeled from their
     silhouettes by render_geometry.py); a product without it keeps its single image, so
     nothing regresses before the data lands. Favorite Picks are outside this on purpose
     (owner, 7:16 in the 09-17 video). */
  var POSITIONS_BY_HANDLE = [
    [/pendant|necklace/, 'chain-first'],
    [/bracelet|earring|stud|hoop/, 'order']
  ];
  var POSITIONS = (function(){
    if (CFG.positions) return String(CFG.positions);
    var h = String((COLLECTION && COLLECTION.handle) || '').toLowerCase();
    if (!h) return 'order';
    for (var i = 0; i < POSITIONS_BY_HANDLE.length; i++) if (POSITIONS_BY_HANDLE[i][0].test(h)) return POSITIONS_BY_HANDLE[i][1];
    return 'laying-first';
  })();
  var POSITION_WANT = { 'laying-first': ['laying', 'standing'], 'standing-first': ['standing', 'laying'], 'chain-first': ['chain', 'laying'] };
  /* A pose and what stands in for it when the photograph set has no exact frame.
     Owner video 2026-09-19: a side-on laying shot as position 1 is a mistake ("it goes
     to the side"), so the top-down frame stands in before it. */
  var POSE_NEAR = { laying: ['laying', 'top', 'laying-side'], standing: ['standing', 'profile', 'straight'], chain: ['chain'] };
  function poseIndex(bucket, pose, skip){
    var list = POSE_NEAR[pose] || [pose];
    for (var k = 0; k < list.length; k++) for (var i = 0; i < bucket.p.length; i++) if (bucket.p[i] === list[k] && i !== skip) return i;
    return -1;
  }
  function viewsBucket(views, metal, strict){
    if (!views) return null;
    if (views[metal]) return views[metal];
    if (strict) return null;
    if (views.mixed) return views.mixed;
    /* `worn` (the product's on-hand shot, card_views.py 2026-09-20) is not a metal bucket */
    var keys = Object.keys(views).filter(function(k){ return k !== 'v' && k !== 'worn'; });
    return keys.length ? views[keys[0]] : null;
  }
  /* {f, b}: position 1 and position 2 for one metal, or null when the product has no
     views. Wanted pose first; missing -> the first image in the product's own order and
     the next one (owner: "you deal with what we have"). */
  function pickViews(views, metal, strict){
    var b = viewsBucket(views, metal, strict);
    if (!b || !b.o || !b.o.length) return null;
    var want = POSITION_WANT[POSITIONS];
    var fi = -1, bi = -1;
    if (want) {
      fi = poseIndex(b, want[0], -1);
      if (fi > -1) bi = poseIndex(b, want[1], fi);
    }
    if (fi < 0) { fi = 0; bi = b.o.length > 1 ? 1 : -1; }
    else if (bi < 0 && b.o.length > 1) bi = fi === 0 ? 1 : 0;
    if (POSITIONS === 'none') bi = -1;
    return { f: cdnSized(b.o[fi]), b: bi > -1 ? cdnSized(b.o[bi]) : '' };
  }
  function cdnSized(src){ return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=640'; }
  /* The metals a card can show a photograph for: the classified views first, the
     variant / filename photos (byColor) as before. */
  function metalPhotos(p){
    var out = {};
    var v = p.images && p.images.views;
    if (v) Object.keys(v).forEach(function(k){ if (k === 'white' || k === 'yellow' || k === 'rose') out[k] = true; });
    var bc = p.images && p.images.byColor;
    if (bc) Object.keys(bc).forEach(function(k){ out[k] = true; });
    return out;
  }
  /* Owner 2026-09-13: a page is 16 PRODUCTS (was 5 rows of cells, which on a 2-column
     phone came to 8 products + the promo). `rowsPerPage` in the section configs is no
     longer read; a page is products-first and rounds UP to a complete row (see renderPage). */
  var PRODUCTS_PER_PAGE = CFG.productsPerPage || 16;
  /* The badge on the image. A lab-grown sapphire is not a "Natural Diamond", so a page
     whose stones are not diamonds names them itself rather than inheriting the default. */
  var ORIGIN_LABELS = CFG.originLabels || {natural: 'Natural Diamond', lab: 'Lab-Grown Diamond'};

  /* QA 2026-09-15 (P-01): on phones the banner hero hides .hero-deck-story / -detail so the
     jewelry stays clear of the copy band. The rest of the intro used to be re-said in a
     paragraph under the hero; owner review 2026-09-20 ("takes up too much space") moved it
     INSIDE the hero copy behind a Read more toggle (phones only, see the stylesheet).
     Approved on Diamond Bridal Sets the same day and rolled out to every collection. The
     detail span is a fragment of the count sentence, so it is capitalised and closed as its
     own sentence here. */
  (function(){
    var hero = document.querySelector('.hero--banner');
    var deck = hero && hero.querySelector('.hero-deck');
    if (!hero || !deck || document.querySelector('.hero-deck-more')) return;
    var story = deck.querySelector('.hero-deck-story'), detail = deck.querySelector('.hero-deck-detail');
    var parts = [];
    if (story) parts.push(story.textContent.trim());
    if (detail) {
      var t = detail.textContent.trim().replace(/[,;]\s*$/, '');
      if (t) parts.push(t.charAt(0).toUpperCase() + t.slice(1) + (/[.!?]$/.test(t) ? '' : '.'));
    }
    if (!parts.length) return;
    var more = document.createElement('p');
    more.className = 'hero-deck hero-deck-more';
    more.id = 'hero-more';
    more.textContent = parts.join(' ');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hero-more-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'hero-more');
    btn.innerHTML = '<span>Read more</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    btn.addEventListener('click', function () {
      var open = hero.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.firstChild.textContent = open ? 'Read less' : 'Read more';
    });
    deck.insertAdjacentElement('afterend', more);
    more.insertAdjacentElement('afterend', btn);
  })();

  var heroCount = document.getElementById('hero-count');
  if (heroCount && COLLECTION.count) heroCount.textContent = COLLECTION.count;
  /* A hero figure marked data-live follows the feed a shopper can actually buy from
     (collection.products_count also counts pieces hidden from the online store: the pendants
     hub said 108 over a feed of 92, 2026-09-08). Opt-in per section, so a hero that quotes a
     deliberately different figure is left alone. */
  if (heroCount && heroCount.hasAttribute('data-live') && PRODUCTS.length) heroCount.textContent = String(PRODUCTS.length);

  /* ---- helpers ---- */
  /* Platinum ships no render of its own and never will — it reads as white gold in a
     photograph, so it points at the white images exactly like the live theme does. */
  var METALS = [
    {key:'white',    src:'white', code:'WG', label:'14K White Gold',  fill:'var(--ps-metal-white)',  ink:'var(--ps-navy)'},
    {key:'yellow',   src:'yellow',code:'YG', label:'14K Yellow Gold', fill:'var(--ps-metal-yellow)', ink:'var(--ps-bg)'},
    {key:'rose',     src:'rose',  code:'RG', label:'14K Rose Gold',   fill:'var(--ps-metal-rose)',   ink:'var(--ps-bg)'},
    {key:'platinum', src:'white', code:'PT', label:'Platinum',        fill:'var(--ps-metal-plat)',   ink:'var(--ps-navy)'}
  ];
  var METAL_LABEL = {white:'White Gold', yellow:'Yellow Gold', rose:'Rose Gold'};
  var METAL_VAR = {white:'var(--ps-metal-white)', yellow:'var(--ps-metal-yellow)', rose:'var(--ps-metal-rose)'};
  var SHAPE_LABEL = {round:'Round', princess:'Princess', emerald:'Emerald', oval:'Oval', cushion:'Cushion', marquise:'Marquise', pear:'Pear', asscher:'Asscher', radiant:'Radiant', heart:'Heart'};
  var BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* PSMoney (layout/ps26): the shopper's currency, never a hard-coded '$' (owner 2026-10-05). */
  function money(n){ return window.PSMoney ? PSMoney.fmt(n, 2) : '$' + Number(n).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}); }
  /* Not anchored to the start of the title: ready-to-ship pieces lead with an adjective
     ("Striking 0.75 CT Round Cut...") and were losing their carat weight entirely. */
  function parseCarat(t){ var m = t.match(/([\d.]+(?:-[\d.]+)?)\s*CT\b/i); return m ? m[1].replace('-', '–') : ''; }
  function parseType(t){ if (/Lab Grown Diamonds/i.test(t)) return 'Lab Grown'; if (/Natural Diamonds/i.test(t)) return 'Natural'; return 'Diamond'; }
  function esc(s){ return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  /* A card's name is derived, never taken from the product title — Shopify titles are
     SEO strings ("2.20-5.20 CT Emerald & Princess Cut Fancy Blue Diamonds - Engagement
     Ring") and would wreck the grid. Multi-shape titles keep both shapes: honest naming. */
  /* Never say the shape twice. On a shape-led page the family label (or the fallback)
     already opens with it, so prefixing the parsed shape doubles it: every card on the
     princess-cut page read "Princess Princess Cut Diamond Jewelry", and the pendants page
     hit the same defect from the other side — one shape meant the fallback was the only
     label and all 22 tiles read the identical string. Fixed in the shell 2026-08-24 so no
     future shape page has to rediscover it. */
  function joinShape(shape, family){
    if (!shape) return String(family).trim();
    var head = String(shape).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (new RegExp('^' + head + '\\b', 'i').test(family)) return String(family).trim();
    return (shape + ' ' + family).trim();
  }
  function displayName(p){
    /* A loose stone is named from its parsed shape. Reading the words after "CT" the way
       a made piece does drags the grades into the name ("F/SI3 Princess Cut Diamond"). */
    if (CARD_MODE === 'stone') {
      return joinShape(SHAPE_LABEL[p.shape] || '', NAME_FALLBACK);
    }
    var m = /CT\s+(.+?)\s+Cut\b/i.exec(p.title);
    var s = m ? m[1] : (SHAPE_LABEL[p.shape] || '');
    var family = NAME_FALLBACK;
    for (var i = 0; i < NAME_FAMILIES.length; i++) {
      if (new RegExp(NAME_FAMILIES[i][0], 'i').test(p.title)) { family = NAME_FAMILIES[i][1]; break; }
    }
    return joinShape(s, family);
  }
  /* The line under the name. A made piece says what it is made of; a loose stone says
     its grades, because that is the only thing a stone shopper is comparing. */
  function specLine(p){
    var carat = parseCarat(p.title);
    if (CARD_MODE === 'stone') {
      var bits = [];
      if (p.carat != null) bits.push(p.carat.toFixed(2) + ' CT');
      else if (carat) bits.push(carat + ' CT');
      if (p.colorGrade && p.clarity) bits.push(p.colorGrade + ' / ' + p.clarity);
      return bits.join(' · ') || 'Certified Diamond';
    }
    /* Only state what the title actually says. parseType falls back to a bare "Diamond"
       when the title names neither natural nor lab-grown, which read as "Diamond Diamonds"
       on the gemstone, fancy-color and ready-to-ship pages. A fancy stone names its
       color instead, which is the useful fact on that card. */
    var bits = [];
    /* Owner review 2026-09-10 (C-05): a plain band carries no carat, its width is the
       fact; the title says it ("6.0 mm Plain Wedding Band ..."). */
    var mm = /^\s*(\d+(?:\.\d+)?)\s*mm(?![a-z])/i.exec(p.title);
    if (mm && /plain wedding band/i.test(p.title)) bits.push(mm[1] + ' mm width');
    if (carat) bits.push(carat + ' CT');
    if (p.fancyColor) {
      bits.push('Fancy ' + p.fancyColor.charAt(0).toUpperCase() + p.fancyColor.slice(1));
    } else {
      var type = parseType(p.title);
      if (type !== 'Diamond') bits.push(type + ' Diamonds');
    }
    return bits.join(' · ');
  }
  function starsHTML(r){
    var full = Math.round(r), out = '';
    for (var i = 0; i < 5; i++) out += '<svg viewBox="0 0 24 24"' + (i < full ? '' : ' style="opacity:.28"') + '><path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z"/></svg>';
    return out;
  }
  function priceHTML(p, cfg){
    /* The approved card spells the saving out and drops the minus sign, which read as a
       negative number rather than a discount. Real values only — a product with no
       compare-at price shows no saving. `cfg` = [price, compareAt|null] of one orderable
       configuration (the selected metal's cheapest available variant): when a metal
       filter is applied the card prices THAT metal, never the cheapest of another. */
    var now = cfg ? cfg[0] : p.priceNow;
    var was = cfg ? cfg[1] : p.priceWas;
    var pct = cfg ? (was ? Math.round((was - now) / was * 100) : 0) : p.pctOff;
    /* Owner 2026-09-23: the collection card shows no percentage; the struck retail
       price, made larger and ruby, carries the saving on its own. */
    var hasOff = !!(was && was > now && pct) && !CARDS26;
    var off = hasOff ? '<span class="off">' + (CARDS26 ? pct + '% off' : '−' + pct + '%') + '</span>' : '';
    return '<span class="price"><span class="now">' + money(now) + '</span>' +
      (was ? '<span class="was">' + money(was) + '</span>' : '') + off + '</span>' +
      /* Owner 2026-10-20 (recording #277, option A): Affirm's own monthly figure under the
         price, filled by pmoScan() for cards on screen. Space is reserved so nothing moves. */
      (now > 0 ? '<span class="pmo" data-amt="' + Math.round(now * 100) + '"></span>' : '');
  }
  /* The card's link carries the variant of the metal it shows, so the product page opens
     on that configuration and price, not on the default metal (prelaunch audit B16). */
  function cardHref(p, metalKey){
    var vid = metalKey && p.vids ? p.vids[metalKey] : null;
    if (!vid) return p.url;
    return p.url + (p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid;
  }
  /* The photograph key a metal opens on: platinum reads as white gold in a photo. */
  function metalSrc(key){
    for (var i = 0; i < METALS.length; i++) if (METALS[i].key === key) return METALS[i].src;
    return key;
  }
  var ONE_STAR = '<svg viewBox="0 0 24 24"><path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z"/></svg>';
  function ratingHTML(p){
    if (p.rating == null) return '';   /* never invent a rating */
    /* The approved card carries ONE star and the number: five stars inside every card
       said the same thing as the reviews section three inches below, louder. */
    if (CARDS26) {
      return '<span class="pcard-rating" aria-label="' + p.rating.toFixed(1) + ' out of 5 stars">' +
        '<span class="stars">' + ONE_STAR + '</span>' + p.rating.toFixed(1) + '</span>';
    }
    return '<span class="pcard-rating"><span class="stars">' + starsHTML(p.rating) + '</span>' + p.rating.toFixed(1) + '</span>';
  }
  /* ---- the approved card's bottom rail ---- */
  function metalFill(key){
    for (var i = 0; i < METALS.length; i++) if (METALS[i].key === key) return METALS[i].fill;
    return '';
  }
  /* The fine bottom edge follows the selected metal; with no selection it falls back to
     the neutral border in CSS. */
  function metalEdgeAttr(key){
    var fill = key ? metalFill(key) : '';
    return fill ? ' style="--card-metal:' + fill + '"' : '';
  }
  function dotHTML(m, on){
    return '<button type="button" class="mdot' + (on ? ' is-sel' : '') + '" data-color="' + m.src + '"' +
      ' style="--m:' + m.fill + ';--mtext:' + m.ink + '" title="' + m.label + '" aria-label="' + m.label + '"' +
      ' aria-pressed="' + (on ? 'true' : 'false') + '"><span class="code">' + m.code + '</span></button>';
  }
  /* Picks only offer the metals the product actually has a photograph for — a swatch
     that cannot change the picture is a promise the card can't keep. */
  function pickDotsHTML(p, sel){
    var bc = p.images.byColor || {};
    var out = METALS.filter(function(m){ return bc[m.src]; })
                    .map(function(m){ return dotHTML(m, m.key === sel); }).join('');
    return out ? '<div class="mdots" role="group" aria-label="Metal color">' + out + '</div>' : '';
  }
  function optionsHTML(dots, rating){
    return (dots || rating) ? '<div class="card-options">' + dots + rating + '</div>' : '';
  }
  /* Renders key metals to {a,b,angles} objects; CDN variant photos key them to plain
     URL strings. Both mean "this piece exists in this metal", so read them the same way. */
  function metalKeys(p){ return p.images.byColor ? Object.keys(p.images.byColor) : []; }
  function frontImg(p){
    if (p.images.source === 'render-drive') {
      var bc = p.images.byColor;
      var k = bc.white ? 'white' : Object.keys(bc)[0];
      return bc[k].a;
    }
    return p.images.single;
  }

  /* ---- pick card (Favorite Picks — static homepage .pcard idiom) ---- */
  function pickCardHTML(p){
    var name = displayName(p);
    /* Picks prefer a generated lifestyle shot (the piece worn) and fall back to the
       product's own photo until that image exists. Picks never hotlink the remote lh3
       URLs in products.js — only the full grid does, because lh3 refuses bursts.

       A render-backed product has no `single`: its keys are byColor + cdn. Falling
       straight through to the local assets/picks/ path 404'd the entire Favorite Picks
       row on every render-backed collection, which is most of them. */
    var img = p.images || {};
    var key = p.pickKey || p.core;   /* config spelling when cores matched tolerantly */
    var isLife = !!PICK_LIFESTYLE[key];
    /* No pick asset (a top-up from the best sellers): the product's own worn shot
       (`images.worn`, the lifestyle upload) before its first image, which since the
       2026-09 render refresh is a white-background render and read as a regression in
       a row of worn shots (owner video 2026-09-19). */
    var src = isLife ? pageAsset('lifestyle/pick-' + key + '.jpg')
                     : img.worn || img.single || img.cdn
                     || pageAsset('picks/' + key + '_' + (PICK_METAL[key] || 'white') + '_04.png');
    if (!isLife && img.worn) isLife = true;
    /* Stone cards are macro shots of the stone itself — nothing is worn. */
    var alt = (isLife && CARD_MODE !== 'stone') ? name + ' worn' : name;
    if (CARDS26) {
      /* An <article> with two links, not one anchor wrapping everything: the approved
         card puts real buttons (the metal swatches) in the same card, and a button
         inside an anchor is invalid and unusable by keyboard. */
      var bc = (CARD_MODE !== 'stone') ? p.images.byColor : null;
      var sel = bc ? (PICK_METAL[key] || (bc.white ? 'white' : Object.keys(bc)[0])) : null;
      var dots = bc ? pickDotsHTML(p, sel) : '';
      if (!dots) sel = null;
      return '<article class="pcard"' +
          (bc ? ' data-imgs="' + esc(JSON.stringify(bc)) + '"' : '') + metalEdgeAttr(sel) + '>' +
        '<a class="pimg' + (isLife ? ' pimg--life' : '') + '" href="' + p.url + '">' +
          '<img src="' + src + '" alt="' + esc(alt) + '" loading="lazy"></a>' +
        '<a class="pmeta" href="' + p.url + '">' +
          '<span class="pname">' + esc(name) + '</span>' +
          '<span class="pspec">' + specLine(p) + '</span>' +
          priceHTML(p) +
        '</a>' +
        optionsHTML(dots, ratingHTML(p)) +
      '</article>';
    }
    return '<a class="pcard" href="' + p.url + '">' +
      '<span class="pimg' + (isLife ? ' pimg--life' : '') + '"><img src="' + src + '" alt="' + esc(alt) + '" loading="lazy"></span>' +
      '<span class="pmeta">' +
        '<span class="pname">' + esc(name) + '</span>' +
        '<span class="pspec">' + specLine(p) + '</span>' +
        ratingHTML(p) + priceHTML(p) +
      '</span>' +
    '</a>';
  }

  /* ---- grid card ---- */
  /* A grid of one metal reads as one product repeated. Each card opens on a metal drawn
     60% white / 20% yellow / 20% rose — scattered, but derived from the rank so it is
     identical on every reload (screenshots and review rounds stay comparable). */
  function defaultMetal(p){
    /* The draw applies to every product that HAS the three metal photographs, however
       they were sourced. Gating on render-drive silently excluded every Shopify-sourced
       page - wedding sets rendered 17 white cards over a byColor set that carried all
       three metals (owner, 2026-09-04: "the items display are showing all in white"). */
    var have = metalPhotos(p);
    var keys = Object.keys(have);
    if (!keys.length) return 'white';
    var r = (p.rank * 2654435761 % 4294967296) % 100;
    var metal = r < 60 ? 'white' : (r < 80 ? 'yellow' : 'rose');
    if (have[metal]) return metal;
    /* A partial set (white + yellow, no rose photograph) used to answer 'white' for a
       rose draw even when white was missing too, so the WG dot lit over a yellow photo.
       Fall to a metal the product actually has. */
    return have.white ? 'white' : keys[0];
  }
  /* The hover / swipe image. On the Drive path it hydrates like the front; on the
     Shopify path it waits in data-src and loads on the first pointer-over or touch, so a
     page of sixteen cards never fetches sixteen extra photographs it may not show (speed
     pass 2026-09). Two dots mark the two positions on a phone only (CSS). */
  function backImgHTML(isRender, backSrc, cdnAttr){
    if (!backSrc) return '';
    if (isRender) return '<img class="pi-back" src="' + BLANK_IMG + '" data-dsrc="' + backSrc + '"' + cdnAttr + ' alt="" aria-hidden="true">';
    return '<img class="pi-back" src="' + BLANK_IMG + '" data-src="' + esc(backSrc) + '" alt="" aria-hidden="true">' +
      '<span class="pi-dots" aria-hidden="true"><i class="on"></i><i></i></span>';
  }
  function loadBack(card){
    var back = card.querySelector('.pi-back[data-src]');
    if (!back) return;
    var src = back.getAttribute('data-src');
    back.removeAttribute('data-src');
    back.onload = function(){ back.onload = null; card.classList.add('back-ready'); };
    back.src = src;
  }
  /* A metal swap on a card that has views: both positions change together, never the
     front alone (owner: "the same color for the two positions"). */
  function setPair(card, pair){
    var front = card.querySelector('.pi-front');
    if (!front) return;
    front.src = pair.f;
    var back = card.querySelector('.pi-back');
    var dots = card.querySelector('.pi-dots');
    if (pair.b) {
      if (!back) {
        front.insertAdjacentHTML('afterend', backImgHTML(false, pair.b, ''));
        back = card.querySelector('.pi-back');
      } else {
        back.removeAttribute('data-dsrc');
        back.setAttribute('data-src', pair.b);
        back.src = BLANK_IMG;
      }
      card.classList.remove('back-ready');
      loadBack(card);   /* the shopper is on this card already */
    } else {
      if (back) back.remove();
      if (dots) dots.remove();
      card.classList.remove('back-ready', 'is-flipped');
    }
  }
  /* `opts.compare === false` omits the compare button (the collection browser has no
     compare tray, so a button that opens nothing is not rendered there). */
  function gridCardHTML(p, opts){
    var name = displayName(p);
    var isRender = p.images.source === 'render-drive';
    /* preferCdn (owner 2026-08-21, gemstone review): on collections whose render
       library misrepresents the product — colorless renders on a color page —
       the LIVE Shopify photo is the truth. Metal dots drop with it, because the
       photo shows one fixed metal. */
    var useCdn = PREFER_CDN && isRender && p.images.cdn;
    if (useCdn) isRender = false;
    var views = (!isRender && !useCdn && p.images.views) ? p.images.views : null;
    var hasMetals = !useCdn && (!!p.images.byColor || !!views) && CARD_MODE !== 'stone';
    /* Under a metal filter the card opens on the metal that matched (first selected
       color the piece is orderable in), and prices that configuration. Otherwise the
       60/20/20 draw. */
    var filterMetal = (state.metal.size && window.PSFilterCore) ? window.PSFilterCore.metalFor(p, Array.from(state.metal)) : null;
    var metal0 = filterMetal || defaultMetal(p);
    var cfg = (filterMetal && p.metals) ? p.metals[filterMetal] : null;
    var byColor = p.images.byColor || {};
    var cdnColor = (hasMetals && !isRender) ? (byColor[metalSrc(metal0)] || p.images.single) : null;
    var renderSet = isRender ? (byColor[metalSrc(metal0)] || byColor[Object.keys(byColor)[0]]) : null;
    /* Position 1 / 2 from the classified views when the product has them (owner
       2026-09-17); the variant / filename photo otherwise; the render pair on the legacy
       Drive path. */
    var pair = views ? pickViews(views, metalSrc(metal0), false) : null;
    var frontSrc = isRender ? renderSet.a : (useCdn ? p.images.cdn : (pair ? pair.f : (cdnColor || p.images.single)));
    var backSrc = isRender ? renderSet.b : (pair ? pair.b : '');
    var metals = '';
    if (hasMetals) {
      metals = CARDS26
        ? '<div class="mdots" role="group" aria-label="Metal color">' +
            METALS.map(function(m){ return dotHTML(m, m.key === metal0); }).join('') + '</div>'
        : '<div class="mdots">' + METALS.map(function(m){
            return '<button type="button" class="mdot' + (m.key === metal0 ? ' is-sel' : '') + '" data-color="' + m.src + '"' +
              ' style="--m:' + m.fill + ';--mtext:' + m.ink + '" title="' + m.label + '" aria-label="' + m.label + '">' +
              '<span class="code">' + m.code + '</span></button>';
          }).join('') + '</div>';
    }
    var shapes = '<div class="sdots" aria-label="Center stone shape: ' + (SHAPE_LABEL[p.shape] || 'not specified') + '">' +
      CARD_SHAPES.map(function(s){
        return '<span class="sdot' + (s === p.shape ? ' is-sel' : '') + '" title="' + SHAPE_LABEL[s] + '">' +
          '<img src="' + dsAsset(s + '.png') + '" alt="" width="14" height="14" loading="lazy"></span>';
      }).join('') + '</div>';
    /* The approved card drops both: the shape row repeated the collection's own shape
       filter on every tile, and the origin badge duplicated the diamond type already
       named in the spec line. The shape FILTER stays. */
    var origin = CARDS26 ? '' :'<span class="pcard-origin">' + esc(ORIGIN_LABELS[p.origin] || ORIGIN_LABELS.natural) + '</span>';
    /* What a swatch swaps to: the metal's own {f, b} pair from the views, else the
       single variant / filename photo. A metal with neither gets no entry. */
    var imgsMap = null;
    if (hasMetals) {
      imgsMap = {};
      ['white', 'yellow', 'rose'].forEach(function(m){
        var pv = views ? pickViews(views, m, true) : null;
        if (pv) imgsMap[m] = pv; else if (byColor[m]) imgsMap[m] = byColor[m];
      });
      if (!views) imgsMap = p.images.byColor;
    }
    var imgsAttr = hasMetals ? ' data-imgs="' + esc(JSON.stringify(imgsMap)) + '"' : '';
    var cdnAttr = isRender && p.images.cdn ? ' data-cdn="' + esc(p.images.cdn) + '"' : '';
    if (CARDS26) {
      var href0 = cardHref(p, hasMetals ? metal0 : null);
      return '<article class="pcard pcard--grid" data-id="' + p.id + '"' + imgsAttr +
          metalEdgeAttr(hasMetals ? metal0 : null) + '>' +
        '<a class="pimg" href="' + href0 + '">' +
          (isRender
            ? '<img class="pi-front" src="' + BLANK_IMG + '" data-dsrc="' + frontSrc + '"' + cdnAttr + ' alt="' + esc(name) + '">'
            : '<img class="pi-front" src="' + frontSrc + '" alt="' + esc(name) + '" loading="lazy">') +
          backImgHTML(isRender, backSrc, cdnAttr) +
        '</a>' +
        ((opts && opts.compare === false) ? '' : '<button type="button" class="pcard-compare" data-id="' + p.id + '" aria-label="Add to compare" aria-pressed="false"><span class="box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>Compare</button>') +
        '<button type="button" class="pcard-wish" aria-label="Add to wishlist" aria-pressed="false"><svg viewBox="0 0 24 24"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/></svg></button>' +
        '<a class="pmeta" href="' + href0 + '">' +
          '<span class="pname">' + esc(name) + '</span>' +
          '<span class="pspec">' + specLine(p) + '</span>' +
          priceHTML(p, cfg) +
        '</a>' +
        optionsHTML(metals, ratingHTML(p)) +
      '</article>';
    }
    return '<article class="pcard pcard--grid" data-id="' + p.id + '"' + imgsAttr + '>' +
      '<a class="pimg" href="' + p.url + '">' +
        (isRender
          ? '<img class="pi-front" src="' + BLANK_IMG + '" data-dsrc="' + frontSrc + '"' + cdnAttr + ' alt="' + esc(name) + '">'
          : '<img class="pi-front" src="' + frontSrc + '" alt="' + esc(name) + '" loading="lazy">') +
        backImgHTML(isRender, backSrc, cdnAttr) +
        origin +
      '</a>' +
      '<button type="button" class="pcard-compare" data-id="' + p.id + '" aria-label="Add to compare"><span class="box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>Compare</button>' +
      '<button type="button" class="pcard-wish" aria-label="Add to wishlist"><svg viewBox="0 0 24 24"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/></svg></button>' +
      '<a class="pmeta" href="' + p.url + '">' +
        '<span class="pname">' + esc(name) + '</span>' +
        '<span class="pspec">' + specLine(p) + '</span>' +
        ratingHTML(p) + priceHTML(p, cfg) +
      '</a>' +
      shapes +
      metals +
    '</article>';
  }

  /* ---- Favorite Picks: ranks 1-6 ---- */
  /* Re-runnable on purpose (2026-09-08, the Colored Diamonds hub): a hub whose picks come
     from menu collections OUTSIDE the parent feed (the fancy bridal sets share nothing with
     fancy-color-diamonds) hands the collection browser's own-feed products in through
     PSCol26.renderPicks(extra). Until that feed lands, a pinned core that has a worn shot
     shows the shot as a placeholder card, so the row never grows from three tiles to six. */
  var PICK_EXTRA = [];
  function renderPicks(extra){
    var el = document.getElementById('picks-grid');
    if (!el) return;
    if (extra && extra.length) PICK_EXTRA = PICK_EXTRA.concat(extra);
    var pool = PRODUCTS.concat(PICK_EXTRA).concat(LOCKED_OUT);
    /* picks.cores (owner rulings 2026-08-21: gemstone stone-mix, loose-diamonds
       six-shapes): an explicit core list overrides the rank-1..6 default, in the
       given order, so a curated row never depends on hoisting ranks in the data. */
    var pickCores = (CFG.picks && CFG.picks.cores) || null;
    /* Live data (ps-col26-products) derives the core from the live handle, which can
       differ from the frozen spelling the curated config and the pick assets use: the
       lab shelf suffixes it (15662 -> 15662lb) and ready-to-ship lowercases it
       (PSRI1385 -> psri1385). An exact-only find returned nothing and the whole
       Favorite Picks row rendered EMPTY on both pages. Match tolerantly, but keep the
       CONFIG spelling on the product (pickKey): the lifestyle/metal maps and the pick
       asset filenames are addressed with it. */
    /* Owner review 2026-09-10 (C-17 / C-18): a pick whose product has no design number
       in its handle ("2-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-
       earrings" derives the core "earrings") can never be found by core, and the card
       rendered blank. picks.handles maps such a pick key to the product handle. */
    var pickHandles = (CFG.picks && CFG.picks.handles) || {};
    function findByCore(c){
      var lc = String(c).toLowerCase();
      var byHandle = pickHandles[c] ? pool.find(function(q){ return q.handle === pickHandles[c]; }) : null;
      if (byHandle) { byHandle.pickKey = c; return byHandle; }
      var p = pool.find(function(q){ return q.core === c; }) ||
              pool.find(function(q){ return String(q.core).toLowerCase() === lc; }) ||
              pool.find(function(q){
                var qc = String(q.core).toLowerCase();
                return qc.indexOf(lc) === 0 && qc.length > lc.length && !/^\d/.test(qc.slice(lc.length));
              });
      if (p) p.pickKey = c;
      return p;
    }
    var html;
    if (pickCores) {
      /* Owner review 2026-09-11 (C-06 / C-07): on a locked page (natural-only shape, budget
         and carat facets) a pinned core the lock dropped can never arrive, so it must not
         sit there as a photo with no name or price. A lab core ("110322lb") falls through to
         its natural sibling ("110322"), keeping the curated hand shot, which pictures the
         same design; anything still unresolved is skipped and the row is topped up from the
         page's own best sellers so it stays six wide. */
      var used = {};
      var cards = pickCores.map(function(c){
        var p = findByCore(c);
        /* the lab spelling can carry a stone suffix too (21099lbov -> 21099ov) */
        if (!p && SHAPE_LOCK && /lb/i.test(String(c))) {
          p = findByCore(String(c).replace(/lb/i, ''));
          if (p) p.pickKey = c;
        }
        if (p && SHAPE_LOCK && used[p.id]) return '';   /* the sibling is already in the row */
        if (p) { used[p.id] = true; return pickCardHTML(p); }
        if (SHAPE_LOCK || !PICK_LIFESTYLE[c]) return '';
        return '<article class="pcard pcard--pending" aria-busy="true"><span class="pimg pimg--life"><img src="' + pageAsset('lifestyle/pick-' + c + '.jpg') + '" alt="" loading="lazy"></span></article>';
      }).filter(Boolean);
      if (SHAPE_LOCK && cards.length < pickCores.length) {
        /* Top-ups: the page's best sellers, those with a worn shot (images.worn) first, so
           the row stays a row of worn shots wherever one exists (owner video 2026-09-19:
           white renders had taken the picks' places on the shape pages). */
        PRODUCTS.slice().sort(function(a, b){
          var wa = a.images && a.images.worn ? 0 : 1, wb = b.images && b.images.worn ? 0 : 1;
          return (wa - wb) || (a.rank - b.rank);
        }).some(function(p){
          if (used[p.id]) return false;
          used[p.id] = true; cards.push(pickCardHTML(p));
          return cards.length >= pickCores.length;
        });
      }
      html = cards.join('');
    } else {
      html = PRODUCTS.filter(function(p){ return p.rank >= 1 && p.rank <= 6; }).sort(function(a, b){ return a.rank - b.rank; }).map(pickCardHTML).join('');
    }
    el.innerHTML = html;
  }
  renderPicks();

  /* Favorite Picks carry NO auto-motion — OWNER RULING 2026-08-20 (round 4): three
     drift implementations in, he saw it live and killed it: "the favorite picks motion
     is not something that looks good right now, so just bring it back to what it used
     to be before." The row stays a one-row swipeable scroller on phones (that part he
     approved); only the reviews marquee moves by itself. Do not reintroduce a picks
     marquee on any collection page. */

  /* ---- Reviews: array-driven, homepage-2026 verbatim fallback ---- */
  var FALLBACK_REVIEWS = [
    {initials:'JC', name:'Jennifer C.', when:'Jul 2026', stars:5, text:'Absolutely love my wedding ring & the experience from start to finish was simple & quick.', src:'via Loox'},
    {initials:'DK', name:'Danielle K.', when:'Jul 2026', stars:5, text:'Amazing service & my rings are more than we could have ever imagined! Absolutely stunning!', src:'via Loox'},
    {initials:'JR', name:'Joe R.', when:'Jun 2026', stars:5, text:'It was a wonderful and surprising proposal that she had no idea would happen. She was in tears and just loved the ring.', src:'via Loox'},
    {initials:'BP', name:'Blaise P.', when:'Mar 2026', stars:5, text:'Ring was perfect and looks even more beautiful in person. I’m a repeat customer and refer everyone to them!', src:'via Loox'},
    {initials:'DG', name:'David G.', when:'Mar 2026', stars:5, text:'What a spectacular completion to my wedding set. Amazing company! Superior design, service and quality!', src:'via Loox'},
    {initials:'RM', name:'Rebecca M.', when:'Feb 2026', stars:5, text:'This ring is stunning!! Absolutely beautiful!!', src:'via Loox'},
    {initials:'ME', name:'Mamie E. B.', when:'Feb 2026', stars:5, text:'My ring is as always absolutely GORGEOUS. I love it. 48 years married to the same man and I am so blessed.', src:'via Loox'},
    {initials:'JC', name:'James C.', when:'Jan 2026', stars:5, text:'Everything went as expected. Ordering process was easy. The ring is beautiful. Fit was perfect. Will definitely buy again.', src:'via Loox'},
    {initials:'KR', name:'Kimberly Reed', when:'Nov 2017', stars:5, text:'My husband purchased this ring set for our 35th anniversary. I wanted bling but simple. It is perfect — it looks much better in person and the sparkle is unbelievable.', src:'via PrimeStyle.com'},
    {initials:'CH', name:'Claire Hellam', when:'Jun 2018', stars:5, text:'I was looking for a semi mount to fit my loose radiant stone. They work with you and provide outstanding customer service. In the end, I was ecstatic.', src:'via PrimeStyle.com'}
  ];
  /* MOCKUP-ONLY, and knowingly imperfect. Only the engagement page has a scraped
     `assets/data/reviews.js`; every other collection lands on FALLBACK_REVIEWS above,
     which is a RING set — a bracelet or earring page therefore shows ring testimonials.
     Do NOT fix that by scraping a static review file per collection (owner decision
     2026-08-18): the reviews block is handed to the Loox app at the Shopify port, where
     it renders real, current, per-collection reviews from actual orders, and any static
     file made now is thrown away and goes stale in the meantime. The port instruction
     lives in the primestyle-web skill, reference/shopify-port.md, "Rewrites during the
     port" item 7. Treat these quotes as layout filler when reviewing a non-ring page. */
  var REVIEWS = (window.PS_REVIEWS && window.PS_REVIEWS.length >= 5) ? window.PS_REVIEWS : FALLBACK_REVIEWS;
  (function renderReviews(){
    var track = document.getElementById('rev-track');
    if (!track) return;
    function cardHTML(r, hidden){
      return '<article class="rvc"' + (hidden ? ' aria-hidden="true"' : '') + '>' +
        '<div class="rvc-top"><span class="rvc-av" aria-hidden="true">' + esc(r.initials) + '</span><div><span class="rvc-name">' + esc(r.name) + '<span class="rvc-verified"><svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.2 14.2-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4Z"/></svg>Verified Buyer</span></span><div class="rvc-when">' + esc(r.when) + '</div></div></div>' +
        '<div class="rvc-stars" aria-label="' + r.stars + ' out of 5 stars">' + starsHTML(r.stars) + '</div>' +
        '<p>' + esc(r.text) + '</p>' +
        '<div class="rvc-src">' + esc(r.src) + '</div>' +
      '</article>';
    }
    track.innerHTML = REVIEWS.map(function(r){ return cardHTML(r, false); }).join('') +
                      REVIEWS.map(function(r){ return cardHTML(r, true); }).join('');
  })();

  /* ---- Drive image loader: lh3 rejects burst hotlinking (ORB), so grid images
     queue through a small concurrency window; each falls back lh3 -> Drive
     thumbnail endpoint -> Shopify CDN copy before giving up. ---- */
  var DRIVE_Q = [], DRIVE_ACTIVE = 0, DRIVE_MAX = 5;
  function driveFileId(u){ var m = /\/d\/([^=?&]+)/.exec(u || ''); return m ? m[1] : null; }
  function pumpDrive(){
    while (DRIVE_ACTIVE < DRIVE_MAX && DRIVE_Q.length) {
      var img = DRIVE_Q.shift();
      if (img.isConnected && img.getAttribute('data-dsrc')) loadDrive(img, 0);
    }
  }
  function loadDrive(img, attempt){
    var base = img.getAttribute('data-dsrc');
    var id = driveFileId(base);
    var url = attempt === 0 ? base + '=w900'
            : (attempt === 1 && id) ? 'https://drive.google.com/thumbnail?id=' + id + '&sz=w900'
            : img.getAttribute('data-cdn') || '';
    if (!url) { pumpDrive(); return; }
    DRIVE_ACTIVE++;
    img.onload = function(){ DRIVE_ACTIVE--; img.onload = img.onerror = null; img.removeAttribute('data-dsrc'); pumpDrive(); };
    img.onerror = function(){
      DRIVE_ACTIVE--; img.onload = img.onerror = null;
      if (attempt < 2) setTimeout(function(){ loadDrive(img, attempt + 1); }, 600 * (attempt + 1));
      pumpDrive();
    };
    img.src = url;
  }
  var driveIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) { driveIO.unobserve(en.target); DRIVE_Q.push(en.target); pumpDrive(); }
    });
  }, { rootMargin: '500px' }) : null;
  function hydrateDriveImgs(scope){
    scope.querySelectorAll('img[data-dsrc]').forEach(function(img){
      if (driveIO) driveIO.observe(img); else { DRIVE_Q.push(img); pumpDrive(); }
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq-q').forEach(function(b){
    b.addEventListener('click', function(){
      var it = b.closest('.faq-item');
      var open = it.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---- scroll reveals (same recipe as homepage-2026, no-JS/reduced-motion = fully visible) ---- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('fx');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.hasAttribute('data-rv-kids')) {
          Array.prototype.forEach.call(el.children, function(kid, i){ kid.style.transitionDelay = Math.min(i * 60, 360) + 'ms'; });
        }
        el.classList.add('in');
        io.unobserve(el);
      });
    }, {threshold: 0.12, rootMargin: '0% 0% -10% 0%'});
    document.querySelectorAll('[data-rv],[data-rv-kids]').forEach(function(el){ io.observe(el); });
  }

  /* ---- metal selection + Favorite Picks interactions ----
     Declared BEFORE the grid guard below (2026-09-08, collection browser): a hub page
     that sections its products (snippets/ps-col26-shelves.liquid) has no #cg-grid, and
     when these sat after `if (!grid) return;` the picks lost their swatches and the
     bracelet favorites lost their arrows on exactly those pages. Same code, earlier. */
  /* metal-swap on the grid: URLs already sit in data-imgs — assign img.src only on click */
  /* One metal-selection routine for both card groups. The grid swaps its front/back
     photographs; a pick leaves its lifestyle shot until a metal is chosen, then shows
     that metal's product photograph (approved card, 2026-09-07). */
  function selectMetal(card, md){
    var imgs = JSON.parse(card.getAttribute('data-imgs') || '{}');
    var picked = imgs[md.getAttribute('data-color')];
    var isPick = !card.classList.contains('pcard--grid');
    if (picked) {
      var front = card.querySelector('.pi-front') || card.querySelector('.pimg img');
      var back = card.querySelector('.pi-back');
      if (typeof picked === 'string') {
        /* CDN variant photo: a plain URL, so assign it directly — there is no Drive
           hydration queue to go through and no second angle to swap. */
        front.src = picked;
        if (!isPick && back && !back.hasAttribute('data-dsrc')) setPair(card, { f: picked, b: '' });
      } else if (picked && picked.f) {
        if (isPick) front.src = picked.f; else setPair(card, picked);
      } else {
        if (isPick) {
          front.src = picked.a;
        } else {
          front.setAttribute('data-dsrc', picked.a); loadDrive(front, 0);
          if (back) { back.setAttribute('data-dsrc', picked.b); loadDrive(back, 0); }
        }
      }
      if (isPick) {
        var shot = card.querySelector('.pimg');
        if (shot) shot.classList.remove('pimg--life');
        var nm = card.querySelector('.pname');
        front.alt = (nm ? nm.textContent : '') + ', ' + md.getAttribute('title');
      }
    }
    card.querySelectorAll('.mdot').forEach(function(d){
      var on = d === md;
      d.classList.toggle('is-sel', on);
      if (CARDS26) d.setAttribute('aria-pressed', String(on));
    });
    if (CARDS26) {
      /* B16: the card now opens and prices the metal the shopper picked */
      var pid = card.getAttribute('data-id'), pp = pid && P_BY_ID ? P_BY_ID[pid] : null;
      if (pp) {
        var mkey = wishMetalKey(card);
        var href = cardHref(pp, mkey);
        card.querySelectorAll('a.pimg, a.pmeta').forEach(function(a){ a.setAttribute('href', href); });
        var priceEl = card.querySelector('.pmeta .price');
        if (priceEl && mkey && pp.metals && pp.metals[mkey]) priceEl.outerHTML = priceHTML(pp, pp.metals[mkey]);
      }
      var fill = md.style.getPropertyValue('--m');
      if (fill) card.style.setProperty('--card-metal', fill);
      var label = card.querySelector('.pname');
      announce((label ? label.textContent + ': ' : '') + md.getAttribute('title') + ' selected.');
    }
  }
  /* Position 2 wiring, on the document so the collection browser's shelves (cards
     outside #cg-grid) get it too. Desktop: the back image loads on the first pointer-over
     and the CSS hover shows it once it is ready. Phone: a horizontal swipe on the photo
     flips the two positions (owner 2026-09-17); a tap still opens the product, and the
     click that follows a swipe is swallowed. */
  document.addEventListener('mouseover', function(e){
    var card = e.target.closest && e.target.closest('.pcard--grid');
    if (card) loadBack(card);
  });
  var swipe = { card: null, x: 0, y: 0, moved: false };
  document.addEventListener('touchstart', function(e){
    var card = e.target.closest && e.target.closest('.pcard--grid .pimg');
    swipe.card = card ? card.closest('.pcard--grid') : null;
    swipe.moved = false;
    if (!swipe.card) return;
    var t = e.touches[0]; swipe.x = t.clientX; swipe.y = t.clientY;
    loadBack(swipe.card);
  }, { passive: true });
  document.addEventListener('touchmove', function(e){
    if (!swipe.card) return;
    var t = e.touches[0], dx = t.clientX - swipe.x, dy = t.clientY - swipe.y;
    if (Math.abs(dx) > 24 && Math.abs(dx) > Math.abs(dy) * 1.5) swipe.moved = true;
  }, { passive: true });
  document.addEventListener('touchend', function(){
    var card = swipe.card;
    swipe.card = null;
    if (!card || !swipe.moved) return;
    if (!card.querySelector('.pi-back')) return;
    var flipped = card.classList.toggle('is-flipped');
    var dots = card.querySelectorAll('.pi-dots i');
    if (dots.length === 2) { dots[0].classList.toggle('on', !flipped); dots[1].classList.toggle('on', flipped); }
    card.__swipedAt = Date.now();
  });
  document.addEventListener('click', function(e){
    var card = e.target.closest && e.target.closest('.pcard--grid');
    if (card && card.__swipedAt && Date.now() - card.__swipedAt < 500) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  /* Favorite Picks are their own container, so they need their own listener; the grid's
     is bound to #cg-grid. Only the approved card puts swatches in a pick. */
  var picksEl = document.getElementById('picks-grid');
  if (CARDS26 && picksEl) {
    picksEl.addEventListener('click', function(e){
      var md = e.target.closest('.mdot');
      if (md) { e.preventDefault(); selectMetal(md.closest('.pcard'), md); }
    });
  }
  /* Owner review 2026-09-11 (MC-01): on a phone the picks row is a swipe row that showed
     one and a half cards and no sign of the other four. The row is wrapped and gets the
     grid's thin progress bar (the visible share of the row, moving with the swipe) and a
     chevron on the right edge that fades after the first swipe. Phones only; the bracelet
     shelf keeps its own arrows and only gets the bar. */
  if (picksEl && window.matchMedia('(max-width:45em)').matches && picksEl.parentNode) {
    var scroller = document.createElement('div');
    scroller.className = 'picks-scroller';
    picksEl.parentNode.insertBefore(scroller, picksEl);
    scroller.appendChild(picksEl);
    if (CARDS_VARIANT !== 'bracelet') {
      var edge = document.createElement('span');
      edge.className = 'picks-edge'; edge.setAttribute('aria-hidden', 'true');
      edge.innerHTML = '<svg viewBox="0 0 24 24"><path d="m9 5 7 7-7 7"/></svg>';
      scroller.appendChild(edge);
    }
    var swipe = document.createElement('div');
    swipe.className = 'picks-swipe';
    swipe.innerHTML = '<div class="barwrap"><div class="bar"></div></div><span class="meta"></span>';
    scroller.parentNode.insertBefore(swipe, scroller.nextSibling);
    var swipeBar = swipe.querySelector('.bar'), swipeMeta = swipe.querySelector('.meta');
    var syncSwipe = function(){
      var n = picksEl.children.length, w = picksEl.scrollWidth, vw = picksEl.clientWidth;
      var more = w > vw + 4;
      swipe.hidden = !more || n < 2;
      if (edge) edge.hidden = !more;
      if (!more) return;
      var end = Math.min(1, (picksEl.scrollLeft + vw) / w);
      swipeBar.style.transform = 'scaleX(' + end.toFixed(3) + ')';
      var seen = Math.max(1, Math.min(n, Math.round(end * n)));
      swipeMeta.textContent = 'Swipe · ' + seen + ' of ' + n;
      if (picksEl.scrollLeft > 8) scroller.classList.add('is-swiped');
    };
    picksEl.addEventListener('scroll', syncSwipe, {passive: true});
    if (window.ResizeObserver) new ResizeObserver(syncSwipe).observe(picksEl);
    if (window.MutationObserver) new MutationObserver(syncSwipe).observe(picksEl, {childList: true});
    syncSwipe();
  }
  /* Bracelet favorites are a manual snap shelf (three wide cards on desktop, one and a
     sliver on a phone), so they need arrows. Touch scrolling and the arrows are the only
     ways it moves — the shelf never advances on its own (owner ruling 2026-08-20 on the
     picks row). Endpoints disable, and re-evaluate on resize. */
  if (CARDS_VARIANT === 'bracelet' && picksEl) {
    var head = document.querySelector('.picks .sh');
    if (head) {
      var nav = document.createElement('div');
      nav.className = 'picks-controls';
      var arrows = [['Previous favorite bracelets', 'm15 5-7 7 7 7'], ['Next favorite bracelets', 'm9 5 7 7-7 7']]
        .map(function(spec, i){
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', spec[0]);
          b.setAttribute('aria-controls', 'picks-grid');
          b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + spec[1] + '"/></svg>';
          b.addEventListener('click', function(){
            picksEl.scrollBy({
              left: (i ? 1 : -1) * picksEl.clientWidth,
              behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'
            });
          });
          nav.appendChild(b);
          return b;
        });
      head.appendChild(nav);
      var syncArrows = function(){
        /* The shelf carries a few pixels of inline padding so a focused card's outline is
           not clipped, and `scroll-snap-align:start` therefore rests the first card at
           scrollLeft === that padding, not 0. Comparing against 0 left the Previous arrow
           enabled at the start of the row. */
        var pad = parseFloat(window.getComputedStyle(picksEl).paddingInlineStart) || 0;
        arrows[0].disabled = picksEl.scrollLeft <= pad + 2;
        arrows[1].disabled = picksEl.scrollLeft >= picksEl.scrollWidth - picksEl.clientWidth - 2;
      };
      picksEl.addEventListener('scroll', syncArrows, {passive: true});
      if (window.ResizeObserver) new ResizeObserver(syncArrows).observe(picksEl);
      else window.addEventListener('resize', syncArrows);
      syncArrows();
    }
  }


  /* ---- Complete grid: filter + sort + paginate ----
     Everything below needs the grid. It is placed last so that a page without one
     still gets its picks, reviews, FAQ and reveals rather than failing silently. */
  /* origin / category / carat (2026-09-03) exist for the search page, whose results
     span departments and both stone types; their chip groups are absent on collection
     pages, so the sets stay empty there and the checks below are inert. */
  var state = { shape: new Set(), metal: new Set(), price: new Set(), stone: new Set(), origin: new Set(), category: new Set(), carat: new Set(), inStock: false, sort: CFG.initialSort || 'rank', min: null, max: null };
  var FILTER_KEYS = ['shape', 'metal', 'price', 'stone', 'origin', 'category', 'carat'];
  var FILTER_ATTR = { shape: 'data-shape', metal: 'data-metal', price: 'data-price', stone: 'data-stone', origin: 'data-origin', category: 'data-category', carat: 'data-carat' };
  var FILTER_BOX = { shape: '#cf-shape', metal: '#cf-metal', price: '#cf-price', stone: '#cf-stone', origin: '#cf-origin', category: '#cf-category', carat: '#cf-carat' };
  var visibleProducts = PRODUCTS.slice();
  var shownCount = 0;
  /* What a page-level script may reuse (2026-09-08, collection browser): the parent feed,
     the approved card renderer, the metal-swap routine and the Drive hydrator. Exposed
     BEFORE the grid guard so a page without #cg-grid still gets them; the event lets a
     deferred script wait for this shell, which the products snippet loads late. */
  window.PSCol26 = { products: PRODUCTS, collection: COLLECTION, cards26: CARDS26, positions: POSITIONS, cardHTML: gridCardHTML, priceHTML: priceHTML, selectMetal: selectMetal, hydrate: hydrateDriveImgs, displayName: displayName, renderPicks: renderPicks, wishToggle: wishToggle, wishSync: wishSync };
  var P_BY_ID = {};
  PRODUCTS.forEach(function(p){ P_BY_ID[p.id] = p; });
  var grid = document.getElementById('cg-grid');
  /* ---- the rest of a large collection (2026-09-09) ----
     The first feed page (48 products) booted this shell; the remaining pages merge in
     here. On an untouched shelf (feed order, no filter) the grid keeps its cards and only
     the counts, pager, picks and drawer options update, because the first 48 ranks are
     already in place and never move. A shelf the shopper has already sorted or filtered
     is re-rendered from the full set. Runs on hub pages without a grid too (their picks and
     the collection browser read the parent feed), and PSCol26.ready settles either way so a
     page script can wait for the whole feed. The callback is a microtask after this boot
     has finished, so every `var` below is assigned by the time it runs. */
  var feedReady = Promise.resolve();
  if (DATA.complete && typeof DATA.complete.then === 'function') {
    feedReady = DATA.complete.then(function(more){
      var added = 0;
      (more || []).forEach(function(p){
        if (!p || P_BY_ID[p.id]) return;
        if (SHAPE_LOCK && !locked(p)) {
          if (originOnly(p)) { if (window.PSFilterCore) window.PSFilterCore.normalizeProduct(p); LOCKED_OUT.push(p); }
          return;
        }
        if (window.PSFilterCore) window.PSFilterCore.normalizeProduct(p);
        PRODUCTS.push(p); P_BY_ID[p.id] = p; added++;
      });
      if (SHAPE_LOCK) {
        COLLECTION.count = PRODUCTS.length;
        if (heroCount) heroCount.textContent = String(PRODUCTS.length);
        if (typeof updatePager === 'function' && grid) updatePager();
      }
      if (DATA.feed) DATA.feed.loaded = PRODUCTS.length;
      COLLECTION.shownCount = PRODUCTS.length;
      if (heroCount && heroCount.hasAttribute('data-live') && PRODUCTS.length) heroCount.textContent = String(PRODUCTS.length);
      if (added) {
        PRODUCTS.sort(function(a, b){ return a.rank - b.rank; });
        if (grid) {
          var active = state.inStock || state.min !== null || state.max !== null || FILTER_KEYS.some(function(k){ return state[k].size; });
          /* The fast path keeps the painted cards. It needs painted cards: when the first
             page left the grid EMPTY (a locked shelf whose first 24 ranks all fell to the
             lock: the owner's three-stone page read "Showing 0 of 55" over the no-match
             notice, 2026-09-19), the merge must render, not just recount. */
          if (!active && state.sort === 'rank' && shownCount) { visibleProducts = sortProducts(PRODUCTS.filter(matchesFilters)); updatePager(); }
          else applyFiltersAndSort();
        }
        renderPicks();
      }
      if (FILTERS26) { if (FILTERS26.rebuild) FILTERS26.rebuild(); if (FILTERS26.feedNotice) FILTERS26.feedNotice(); }
      syncClaims();
      try { document.dispatchEvent(new CustomEvent('ps:col26:complete')); } catch (e) {}
    }, function(){});
  } else {
    syncClaims();
  }
  window.PSCol26.ready = feedReady;
  /* The copy's catalog claims ("as low as $X", "All N designs") are literals refreshed by
     tools/refresh_collection_claims.py; once the whole feed is here they follow it, so a
     page never promises a price or a count the grid below cannot show (audit B11). */
  function syncClaims(){
    if (!PRODUCTS.length) return;
    var mn = Infinity, mx = 0;
    PRODUCTS.forEach(function(p){ if (p.priceNow > 0) { if (p.priceNow < mn) mn = p.priceNow; if (p.priceNow > mx) mx = p.priceNow; } });
    if (isFinite(mn)) document.querySelectorAll('[data-col-min]').forEach(function(e){ var s = money(mn); if (e.textContent !== s) e.textContent = s; });
    if (mx) document.querySelectorAll('[data-col-max]').forEach(function(e){ var s = money(mx); if (e.textContent !== s) e.textContent = s; });
    document.querySelectorAll('[data-col-count]').forEach(function(e){ var s = String(PRODUCTS.length); if (e.textContent !== s) e.textContent = s; });
  }
  /* 'ps:col26' fires AFTER ready is attached (2026-09-10): the collection browser boots
     on this event and waits on PSCol26.ready for the whole parent feed; when the event
     fired before ready existed, a multi-page parent (round rings: 17 pages) settled
     its shelves against the first page alone (engagement rings: 2 of 95). */
  try { document.dispatchEvent(new CustomEvent('ps:col26')); } catch (e) {}
  /* the wishlist app loads deferred and calls this when it is ready; keep any
     handler another section already registered */
  (function(){
    var prev = window.iWishinitFn;
    window.iWishinitFn = function(){
      if (typeof prev === 'function') { try { prev(); } catch (e) {} }
      wishSync();
    };
    window.setTimeout(wishSync, 1500);
  })();
  /* The compare tray + modal used to sit below `if (!grid) return;` and so never
     existed on a hub page. Moved above the guard (owner review 2026-09-10, C-01): the
     collection browser's shelves carry the same compare button and tray now. Every
     helper it uses is defined above this point. */
  /* ---- compare tray + modal ---- */
  var MAXCMP = 4, compareSet = [];
  function toggleCompare(id){
    var i = compareSet.indexOf(id);
    if (i > -1) compareSet.splice(i, 1);
    else { if (compareSet.length >= MAXCMP) { flashHint(); return; } compareSet.push(id); }
    renderTray();
  }
  function removeCompare(id){ var i = compareSet.indexOf(id); if (i > -1) compareSet.splice(i, 1); renderTray(); }
  function flashHint(){
    document.getElementById('cg-ctray').classList.add('open');
    var h = document.getElementById('cg-ctray-hint');
    h.textContent = 'You can compare up to ' + MAXCMP + ' ' + NOUN;
    h.classList.add('show');
    setTimeout(function(){ h.classList.remove('show'); h.textContent = 'Select up to ' + MAXCMP + ' ' + NOUN; }, 1900);
  }
  function syncCompareUI(){
    if (!compareSet) return; /* first renderPage() runs before this block initializes */
    document.querySelectorAll('.pcard-compare').forEach(function(b){
      var on = compareSet.indexOf(b.getAttribute('data-id')) > -1;
      b.classList.toggle('is-on', on);
      /* Clearing the tray has to clear the pressed state too, not just the styling. */
      if (CARDS26) b.setAttribute('aria-pressed', String(on));
    });
  }
  function renderTray(){
    document.getElementById('cg-ctray-count').textContent = 'Compare (' + compareSet.length + '/' + MAXCMP + ')';
    document.getElementById('cg-ctray-items').innerHTML = compareSet.map(function(id){
      return '<div class="ctray-item"><img src="' + frontImg(P_BY_ID[id]) + '" alt=""><button class="rm" data-id="' + id + '" aria-label="Remove">&times;</button></div>';
    }).join('');
    document.getElementById('cg-ctray').classList.toggle('open', compareSet.length > 0);
    document.body.classList.toggle('has-ctray', compareSet.length > 0);
    var tbb = document.getElementById('tb-compare-badge');
    if (tbb) { tbb.hidden = compareSet.length === 0; tbb.textContent = compareSet.length; }
    syncCompareUI();
  }
  /* Toolbar COMPARE (replaces the In-Stock toggle, owner 2026-08-20): the persistent
     answer to "where do I see my comparison?". With picks ticked it opens the table;
     empty, it surfaces the tray hint that explains what to do. */
  var tbCompareBtn = document.getElementById('tb-comparebtn');
  if (tbCompareBtn) {
    tbCompareBtn.addEventListener('click', function(){
      if (compareSet.length) openCompareModal(); else flashHint();
    });
  }

  /* Owner review 2026-09-10 (C-01): the collection browser (hub pages) gets the same
     compare tool as a grid page. Its shelves render cards outside #cg-grid and may
     carry pieces the parent feed never had, so it registers them and toggles here. */
  window.PSCol26.compare = {
    toggle: toggleCompare,
    register: function(p){ if (p && p.id != null && !P_BY_ID[p.id]) P_BY_ID[p.id] = p; },
    sync: syncCompareUI
  };
  var ctray = document.getElementById('cg-ctray');
  if (ctray) {
    document.getElementById('cg-ctray-items').addEventListener('click', function(e){
      var rm = e.target.closest('.rm');
      if (rm) removeCompare(rm.getAttribute('data-id'));
    });
    document.getElementById('cg-ctray-clear').addEventListener('click', function(){ compareSet = []; renderTray(); });
    document.getElementById('cg-ctray-open').addEventListener('click', openCompareModal);
  }
  function openCompareModal(){
    if (!compareSet.length) return;
    var prods = compareSet.map(function(id){ return P_BY_ID[id]; });
    var head = '<th class="rowlabel"></th>' + prods.map(function(p){
      return '<th><div class="ci-img"><img src="' + frontImg(p) + '" alt=""></div><div class="ci-name">' + esc(displayName(p)) + '</div></th>';
    }).join('');
    function row(label, vals){ return '<tr><th class="rowlabel">' + label + '</th>' + vals.map(function(v){ return '<td>' + v + '</td>'; }).join('') + '</tr>'; }
    var body = '';
    body += row('Price', prods.map(function(p){ return '<span class="ci-now">' + money(p.priceNow) + '</span>'; }));
    body += row('Retail', prods.map(function(p){ return p.priceWas ? '<span class="ci-was">' + money(p.priceWas) + '</span>' : '—'; }));
    body += row('Total Carat', prods.map(function(p){ return (parseCarat(p.title) || '—') + ' ct'; }));
    body += row('Center Shape', prods.map(function(p){ return SHAPE_LABEL[p.shape] || '—'; }));
    body += row('Rating', prods.map(function(p){ return p.rating != null ? '<span class="cmp-stars">' + starsHTML(p.rating) + '</span> ' + p.rating.toFixed(1) : 'Not yet rated'; }));
    if (CARD_MODE === 'stone') {
      body += row('Color / Clarity', prods.map(function(p){ return (p.colorGrade && p.clarity) ? p.colorGrade + ' / ' + p.clarity : '—'; }));
    } else {
      body += row('Metals', prods.map(function(p){
        var keys = metalKeys(p);
        if (!keys.length) return 'One metal photographed';
        return keys.map(function(c){ return '<span class="cmp-sw" style="background:' + METAL_VAR[c] + '" title="' + METAL_LABEL[c] + '"></span>'; }).join('');
      }));
    }
    body += row('Diamond', prods.map(function(p){ return parseType(p.title) + ' &middot; Certified'; }));
    body += row('', prods.map(function(p){ return '<a class="cmp-view" href="' + p.url + '">View Details</a>'; }));
    var tbl = document.getElementById('cg-cmp-table');
    tbl.innerHTML = '<thead><tr>' + head + '</tr></thead><tbody>' + body + '</tbody>';
    /* the phone layout lays each attribute out as one row of N products */
    tbl.style.setProperty('--cmp-n', prods.length);
    var m = document.getElementById('cg-cmodal');
    /* announced as a dialog, and Tab kept inside it. Set here rather than in the
       markup because the same panel is duplicated across 110 section files. */
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    var heading = m.querySelector('.cmodal-head h3');
    if (heading) {
      if (!heading.id) heading.id = 'cg-cmodal-title';
      m.setAttribute('aria-labelledby', heading.id);
    }
    m.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    cmpLastFocus = document.activeElement;
    m.addEventListener('keydown', cmpTrap);
    /* The panel fades in, and focus() on a still-hidden element is silently
       dropped, so keep trying for the length of the transition rather than
       guessing a delay. */
    focusWhenVisible(document.getElementById('cg-cmclose'));
  }
  /* Tab used to walk straight out of the open comparison and into the page behind
     it, with no way back except a mouse. */
  var cmpLastFocus = null;
  function focusWhenVisible(el, tries){
    if (!el) return;
    tries = tries === undefined ? 12 : tries;
    if (el.offsetParent !== null) {
      try { el.focus(); } catch (e) {}
      if (document.activeElement === el || tries <= 0) return;
    }
    if (tries <= 0) return;
    window.requestAnimationFrame(function(){ focusWhenVisible(el, tries - 1); });
  }
  function cmpTrap(e){
    if (e.key !== 'Tab') return;
    var m = document.getElementById('cg-cmodal');
    var all = m.querySelectorAll('a[href],button:not([disabled]):not([hidden]),input:not([type="hidden"]),select,textarea');
    var list = Array.prototype.filter.call(all, function(el){ return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function closeCompareModal(){
    var m = document.getElementById('cg-cmodal');
    if (m && m.classList.contains('open')) {
      m.classList.remove('open');
      document.documentElement.style.overflow = '';
      m.removeEventListener('keydown', cmpTrap);
      if (cmpLastFocus && cmpLastFocus.focus) cmpLastFocus.focus();   /* back where they were */
      cmpLastFocus = null;
    }
  }
  var cmClose = document.getElementById('cg-cmclose');
  if (cmClose) {
    cmClose.addEventListener('click', closeCompareModal);
    document.getElementById('cg-cmodal').addEventListener('click', function(e){ if (e.target === this) closeCompareModal(); });
  }

  if (!grid) return;
  var pagerMeta = document.getElementById('cg-pager-meta');
  var pagerBar = document.getElementById('cg-pager-bar');
  var loadmoreBtn = document.getElementById('cg-loadmore');
  var tbCountN = document.getElementById('tb-count-n');
  var tbCountTotal = document.getElementById('tb-count-total');

  function priceBandMatch(band, price){
    var parts = band.split('-'); var lo = Number(parts[0]), hi = Number(parts[1]);
    return price >= lo && price <= hi;
  }
  function matchesFilters(p){
    if (state.inStock && !p.inStock) return false;
    if (state.shape.size && !state.shape.has(p.shape)) return false;
    /* Stone color, for pages whose products differ by the color of the stone rather
       than the metal (fancy blue / pink / yellow). Inert where no chips exist. */
    if (state.stone.size && !state.stone.has(p.fancyColor)) return false;
    if (state.origin.size && !state.origin.has(p.origin)) return false;
    if (state.category.size && !state.category.has(p.category)) return false;
    if (state.carat.size) {
      var okc = false;
      (p.caratBands || []).forEach(function(b){ if (state.carat.has(b)) okc = true; });
      if (!okc) return false;
    }
    if (state.metal.size) {
      var ok = false;
      if (p.metals) {
        /* The live feed says which colors a piece is ORDERABLE in (its own metal
           option, available variants only). Photographs no longer decide this. */
        state.metal.forEach(function(m){ if (p.metals[m]) ok = true; });
      } else if (FILTERS26) {
        /* Live data with no orderable color recorded: not a match, never a guess. */
        ok = false;
      } else {
        /* Legacy path (the search page builds photo-derived chips): an image in that
           metal, with platinum reading the white image exactly like the card swatches. */
        if (!p.images.byColor) return false;
        state.metal.forEach(function(m){
          var src = (m === 'platinum') ? 'white' : m;
          if (p.images.byColor[src]) ok = true;
        });
      }
      if (!ok) return false;
    }
    if (state.min !== null || state.max !== null) {
      /* The SAME configuration has to satisfy metal and price: with a metal selected the
         price judged is the cheapest available variant in one of the chosen colors. */
      var cfgPrice = window.PSFilterCore ? window.PSFilterCore.configPrice(p, Array.from(state.metal)) : p.priceNow;
      if (cfgPrice === null) return false;
      if (state.min !== null && cfgPrice < state.min) return false;
      if (state.max !== null && cfgPrice > state.max) return false;
    }
    if (state.price.size) {
      var ok2 = false;
      state.price.forEach(function(band){ if (priceBandMatch(band, p.priceNow)) ok2 = true; });
      if (!ok2) return false;
    }
    return true;
  }
  function sortProducts(list){
    var s = state.sort;
    var copy = list.slice();
    /* Sort on the price the card is SHOWING. The grid reprices to the selected
       metal but the sort still used the base price, so with a metal chosen a
       low-to-high list could run $3,000 then $2,000. Same helper the price filter
       uses, so the two can no longer disagree. */
    var metalSel = Array.from(state.metal);
    function sortPrice(p){
      var v = (window.PSFilterCore && window.PSFilterCore.configPrice)
        ? window.PSFilterCore.configPrice(p, metalSel) : p.priceNow;
      return (v === null || v === undefined || !isFinite(v)) ? Infinity : v;
    }
    if (s === 'price-asc') copy.sort(function(a, b){ return sortPrice(a) - sortPrice(b); });
    else if (s === 'price-desc') copy.sort(function(a, b){ return sortPrice(b) - sortPrice(a); });
    else if (s === 'newest') copy.sort(function(a, b){ return new Date(b.createdAt) - new Date(a.createdAt); });
    else copy.sort(function(a, b){ return a.rank - b.rank; });
    return copy;
  }
  function gridCols(){
    var cs = getComputedStyle(grid).gridTemplateColumns;
    /* Read the repeat() count when that is what we are handed. The Shopify base theme
       hides every empty container (base.css: `div:empty:not(.ignore-empty){display:none}`)
       and this grid ships empty, so on the very first render the element is display:none
       and reports the UNRESOLVED value "repeat(4, 1fr)" instead of four pixel tracks.
       Splitting that on spaces counts 2, so a 4-column desktop page sized itself as a
       2-column one: eight products and a promo where seventeen products belong, and the
       page ended two and a half rows in with a half-empty row under it. The stylesheet
       now keeps #cg-grid displayed while empty as well, but the parse stays: a hidden
       grid must still measure correctly. */
    var rep = /^repeat\((\d+)/.exec(cs);
    if (rep) return Math.max(1, parseInt(rep[1], 10));
    if (!cs || cs === 'none') return 1;
    return Math.max(1, cs.split(' ').filter(Boolean).length);
  }
  function updatePager(){
    var total = visibleProducts.length;
    if (pagerMeta) pagerMeta.textContent = 'Showing ' + shownCount + ' of ' + total;
    if (pagerBar) pagerBar.style.transform = 'scaleX(' + (total ? shownCount / total : 0) + ')';
    if (loadmoreBtn) loadmoreBtn.style.display = shownCount >= total ? 'none' : '';
    if (tbCountN) tbCountN.textContent = shownCount;
    if (tbCountTotal) tbCountTotal.textContent = total;
  }

  /* ---- creative slots woven into the grid ----
     Owner rule 2026-08-13: every 16th slot in the grid is a creative — an image, a
     promotion, or related copy. Where the image exists it renders; where it does not,
     a marked placeholder holds the exact space so the ratio can be judged now and the
     creative dropped in later. The 2-wide custom-design promo lands once, on page 1.
     Page budget is counted in CELLS and a tile's span is deducted from the product
     slice, so every page still fills complete rows. */
  function modelTileHTML(i){
    var t = LIFESTYLE_TILES[i];
    if (!t) return slotTileHTML(i);
    return '<a class="etile etile-model" href="' + (MODEL_TILE.href || '#grid-top') + '">' +
      '<img src="' + t.img + '" alt="' + esc(t.alt) + '" loading="lazy">' +
      '<span class="etile-grad"></span>' +
      /* Each tile may carry its OWN promo line (owner rule 2026-08-18: the every-16 cards
         say something promotional about PrimeStyle, e.g. "Up to 78% off direct factory
         prices" or "Over 100K customers since 2001"). A shared eyebrow across eleven
         cards wastes eleven chances to say something. MODEL_TILE.eyebrow stays the
         fallback so a page that has not written its lines yet still renders. */
      '<span class="etile-body"><span class="etile-eyebrow">' + esc(t.eyebrow || MODEL_TILE.eyebrow || 'Hand-Set Since 2001') + '</span>' +
      '<span class="etile-cta">' + esc(MODEL_TILE.cta || 'Shop the collection') + ' ' + ARROW_SVG + '</span></span></a>';
  }
  function slotTileHTML(i){
    return '<div class="etile etile-slot" data-slot="' + (i + 1) + '">' +
      '<svg class="mark" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 22 9l-10 13L2 9z"/></svg>' +
      '<span class="etile-eyebrow">Creative Slot</span>' +
      '<span class="slot-n">' + (i + 1) + '</span>' +
      '<p>Image, promotion or related copy — one every ' + TILE_EVERY + ' products.</p>' +
    '</div>';
  }
  function promoTileHTML(){
    if (!PROMO_TILE) return '';
    return '<article class="etile etile-promo">' +
      '<div class="etile-promo-img"><img src="' + PROMO_TILE.img + '" alt="' + esc(PROMO_TILE.alt || '') + '" loading="lazy"></div>' +
      '<div class="etile-promo-copy"><span class="etile-eyebrow">' + esc(PROMO_TILE.eyebrow || 'Custom Design') + '</span>' +
      '<h3>' + PROMO_TILE.heading + '</h3>' +
      '<p>' + PROMO_TILE.body + '</p>' +
      '<a class="etile-btn" href="' + PROMO_TILE.href + '">' + esc(PROMO_TILE.cta || 'Start Your Design') + ' ' + ARROW_SVG + '</a></div></article>';
  }
  /* Boundaries are absolute product positions — 16, 32, 48 — not "every TILE_EVERY
     products from the top of this page". Counting per page silently drops every tile
     whenever the page size is smaller than TILE_EVERY: a 3-column grid renders 15 cells
     a page, so `fromIndex + 16` always overshot the page and no creative slot ever
     appeared. Deriving the tile's index from the boundary also makes it stable across
     filtering, instead of depending on a counter that has to be reset by hand. */
  function nextTiles(fromIndex, count){
    var out = [];
    var first = (Math.floor(fromIndex / TILE_EVERY) + 1) * TILE_EVERY;
    for (var n = first; n <= fromIndex + count; n += TILE_EVERY) {
      var i = n / TILE_EVERY - 1;
      if (i >= MAX_TILES) break;
      out.push({at: n - fromIndex, html: modelTileHTML(i), span: 1});
    }
    return out;
  }
  function renderPage(){
    if (shownCount >= visibleProducts.length) { updatePager(); return; }
    var cols = gridCols();
    var firstPage = shownCount === 0;
    /* Reserve cells for the creatives this page will carry, so every page ends on a
       COMPLETE row. The count must come from the real every-16 boundaries — asking
       `target / TILE_EVERY` was wrong in both directions: a 2-column phone page (target
       10) reserved floor(10/16) = 0 cells and still received the tile crossing absolute
       position 16, which left a half-empty row above Load More on every mobile page;
       and past the MAX_TILES cap it kept reserving a cell for a tile that no longer
       renders. Deriving it from nextTiles() keeps one source of truth for both. It takes
       a couple of passes because the tile count depends on the slice length and the
       slice length on the tile count; it converges immediately in practice and the loop
       is bounded. */
    /* The custom card is two cells wide, EXCEPT on a one-column grid, where its CSS is
       `grid-column:1/-1` and it fills a single cell. Reserving two there left the first
       page one product short of a full page. Reserve what it will actually occupy. */
    var promoSpan = Math.min(2, cols);
    var promoCells = (firstPage && PROMO_TILE) ? promoSpan : 0;
    /* Products first (owner 2026-09-13: 16 at the start, 16 more per Load More), then the
       creatives this page carries, then the fewest extra products that end the page on a
       COMPLETE row (a 16-product page plus one tile is 17 cells, one short of a 2-column
       row). Adding products can cross the next every-16 boundary and pull in another
       tile, so the loop re-measures; it converges in one or two passes and is bounded. */
    var sliceLen = PRODUCTS_PER_PAGE;
    for (var pass = 0; pass < 4; pass++) {
      var cells = sliceLen + promoCells + nextTiles(shownCount, sliceLen).length;
      var pad = (cols - cells % cols) % cols;
      if (!pad) break;
      sliceLen += pad;
    }
    var slice = visibleProducts.slice(shownCount, shownCount + sliceLen);
    var parts = slice.map(gridCardHTML);
    /* splice tiles in from the end so earlier indices stay valid */
    var inserts = nextTiles(shownCount, slice.length);
    if (firstPage && PROMO_TILE && slice.length >= cols * 2) {
      /* Row-align the custom card and keep it inside the grid. Asking for `cols * 2`
         outright put it past the `parts.length - cols` guard below on any short shelf --
         an 11-product collection at 3 or 4 columns dropped it silently, which is how the
         gemstone page shipped with no custom card at all (owner, 2026-09-05). Clamping to
         the last WHOLE row that still leaves a row beneath keeps the 2-cell block off the
         final row without losing it. */
      var promoMaxAt = Math.floor((slice.length - cols) / cols) * cols;
      inserts.push({at: Math.min(cols * 2, promoMaxAt), html: promoTileHTML(), span: promoSpan});
    }
    inserts.sort(function(a, b){ return b.at - a.at; })
      .forEach(function(t){
        /* Never at index 0. The wide promo additionally stays out of the final row,
           where a 2-cell block can strand a gap; a 1-cell creative slot fills exactly
           one cell like a product and so can sit anywhere, including the last row. */
        var limit = t.span > 1 ? parts.length - cols : parts.length;
        if (t.at > 0 && t.at <= limit) parts.splice(t.at, 0, t.html);
      });
    grid.insertAdjacentHTML('beforeend', parts.join(''));
    shownCount += slice.length;
    hydrateDriveImgs(grid);
    updatePager();
    syncCompareUI();
    wishSync();   /* freshly drawn cards must show what is already saved */
  }
  function applyFiltersAndSort(){
    visibleProducts = sortProducts(PRODUCTS.filter(matchesFilters));
    shownCount = 0;
    grid.innerHTML = '';
    renderPage();
    var emptyEl = document.getElementById('cg-empty');
    if (emptyEl) emptyEl.hidden = visibleProducts.length !== 0;
    var pagerEl = document.querySelector('.pager');
    if (pagerEl) pagerEl.style.display = visibleProducts.length ? '' : 'none';
    var activeCount = (state.inStock ? 1 : 0) + ((state.min !== null || state.max !== null) ? 1 : 0);
    FILTER_KEYS.forEach(function(k){ activeCount += state[k].size; });
    var badge = document.getElementById('tb-filter-badge');
    if (badge) {
      if (activeCount) { badge.hidden = false; badge.textContent = activeCount; } else { badge.hidden = true; }
    }
    if (FILTERS26) { FILTERS26.afterApply(); }
    else { renderApplied(); syncUrl(); }
  }

  /* ---- applied filters as removable pills (2026-09-03; renders only where the
     page provides #cg-applied — the search page today) ---- */
  function chipLabel(key, val){
    var box = document.querySelector(FILTER_BOX[key]);
    var c = box && box.querySelector('[' + FILTER_ATTR[key] + '="' + val + '"]');
    if (!c) return val;
    var t = c.cloneNode(true); var n = t.querySelector('.fchip-n'); if (n) n.remove();
    return t.textContent.trim();
  }
  function setChip(key, val, on){
    var box = document.querySelector(FILTER_BOX[key]);
    var c = box && box.querySelector('[' + FILTER_ATTR[key] + '="' + val + '"]');
    if (c) c.classList.toggle('on', on);
  }
  function renderApplied(){
    var host = document.getElementById('cg-applied');
    if (!host) return;
    var pills = [];
    FILTER_KEYS.forEach(function(k){ state[k].forEach(function(v){ pills.push('<button type="button" class="ap" data-key="' + k + '" data-val="' + esc(v) + '" aria-label="Remove filter ' + esc(chipLabel(k, v)) + '">' + esc(chipLabel(k, v)) + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'); }); });
    host.innerHTML = pills.length ? pills.join('') + '<button type="button" class="ap-clear" data-key="*">Clear all</button>' : '';
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest('#cg-applied [data-key]');
    if (!b) return;
    var k = b.getAttribute('data-key');
    if (k === '*') { FILTER_KEYS.forEach(function(key){ state[key].forEach(function(v){ setChip(key, v, false); }); state[key].clear(); }); }
    else { var v = b.getAttribute('data-val'); state[k].delete(v); setChip(k, v, false); }
    applyFiltersAndSort();
  });

  /* ---- URL state (2026-09-03): only where the page asks for it (CFG.urlState, the
     search page), so a filtered search can be shared and survives a reload; collection
     pages keep their URL untouched. ---- */
  function syncUrl(){
    if (!CFG.urlState || !window.history || !window.history.replaceState) return;
    var u = new URL(window.location.href);
    FILTER_KEYS.forEach(function(k){
      var vals = Array.from(state[k]);
      if (vals.length) u.searchParams.set('f_' + k, vals.join(',')); else u.searchParams.delete('f_' + k);
    });
    if (state.sort && state.sort !== 'rank') u.searchParams.set('f_sort', state.sort); else u.searchParams.delete('f_sort');
    window.history.replaceState(null, '', u.toString());
  }
  function readUrl(){
    if (!CFG.urlState) return;
    var u = new URL(window.location.href);
    FILTER_KEYS.forEach(function(k){
      var raw = u.searchParams.get('f_' + k);
      if (!raw) return;
      raw.split(',').forEach(function(v){
        var box = document.querySelector(FILTER_BOX[k]);
        if (box && box.querySelector('[' + FILTER_ATTR[k] + '="' + v + '"]')) { state[k].add(v); setChip(k, v, true); }
      });
    });
    var s = u.searchParams.get('f_sort');
    if (s && /^(rank|price-asc|price-desc|newest)$/.test(s)) state.sort = s;
  }
  /* ---- filter drawer 2026 (approved: landing-pages/filter-mockup, owner 2026-09-07) ----
     Runs only where snippets/ps-col26-filters.liquid rendered the <dialog>. The options
     come from the data, never from markup: shapes, orderable metals (feed `metals`),
     origins and stone colors the collection actually holds, and its real price range.
     Draft state lives in the drawer; Apply commits it into the shell's `state` and
     re-renders; Close / Escape / backdrop discard the draft. The legacy .fdrawer path
     above stays for the search page, which builds its own chips. */
  var F = window.PSFilterCore;
  var psfDialog = document.getElementById('psf-dialog');
  if (psfDialog && F && typeof psfDialog.showModal === 'function') (function(){
    var FCFG = CFG.filters || {};
    var $ = function(id){ return document.getElementById(id); };
    var CHECK = '<svg class="psf-check" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4 10-10"/></svg>';
    var CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
    var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m-6-6 6 6-6 6"/></svg>';
    var STONE_TOKEN = {blue: 'var(--ps-powder-600)', pink: 'var(--ps-blush-300)', yellow: 'var(--ps-gold-star)'};
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Snapshot datasets (the _ds mockups) carry no variant data. There, and ONLY there,
       photographs stand in for orderable metals so the drawer can be designed against;
       the live feed always ships `metals` and never takes this branch. */
    if (COLLECTION.source !== 'live' && !PRODUCTS.some(function(p){ return p.metals; })) {
      PRODUCTS.forEach(function(p){ var m = F.photoMetals(p); if (m) p.metals = m; });
      if (window.console) console.warn('PS filters: snapshot data, metal availability read from photographs. The live feed carries variant metals.');
    }

    var avail, GROUPS = {}, SHOW_PRICE, PRESETS, SLIDER_MAX, total;
    function computeOptions(){
      avail = F.availableValues(PRODUCTS);
      F.LIST_GROUPS.forEach(function(g){
        var vals = (FCFG[g] === false) ? [] : avail[g];
        if (g === 'metal' && !avail.hasMetalData) vals = [];
        /* Diamond color is a specialized group: the fancy-color shelf opts in with
           `filters: {stone: true}`. A broad ring page also holds fancy stones, but it has no
           verified "colorless" value to offer beside them, so it does not show the group. */
        if (g === 'stone' && FCFG.stone !== true) vals = [];
        GROUPS[g] = vals.length >= 2 ? vals : [];
      });
      SHOW_PRICE = FCFG.price !== false && avail.prices.length > 1;
      PRESETS = SHOW_PRICE ? F.presets(avail.prices, FCFG.priceSteps) : [];
      SLIDER_MAX = F.sliderMax(avail.prices);
      total = PRODUCTS.length;
    }
    computeOptions();
    var applied = F.cleanState(), draft = F.cleanState();
    var opener = null;
    var nounOf = function(n){ return n === 1 ? (CFG.nounOne || 'design') : (CFG.nounMany || 'designs'); };

    /* ---- build the option controls once ---- */
    function optHTML(g, v){
      var label = F.LABELS[g][v];
      if (g === 'metal') {
        var m = F.METALS.filter(function(x){ return x.key === v; })[0];
        return '<button type="button" class="psf-opt psf-metal" data-group="metal" data-value="' + v + '" aria-pressed="false">' +
          '<span class="psf-swatch" style="--swatch:var(--ps-metal-' + m.token + ')"></span>' +
          '<span class="psf-label">' + esc(label) + '<span class="psf-n"></span></span>' + CHECK + '</button>';
      }
      if (g === 'stone') {
        return '<button type="button" class="psf-opt psf-metal" data-group="stone" data-value="' + v + '" aria-pressed="false">' +
          '<span class="psf-swatch" style="--swatch:' + STONE_TOKEN[v] + '"></span>' +
          '<span class="psf-label">' + esc(label) + '<span class="psf-n"></span></span>' + CHECK + '</button>';
      }
      if (g === 'shape') {
        var ill = F.SHAPE_ICONS.indexOf(v) > -1 ? '<svg class="psf-shape-ill" viewBox="0 0 48 48" aria-hidden="true"><use href="#shp-' + v + '"/></svg>' : '';
        return '<button type="button" class="psf-opt psf-shape" data-group="shape" data-value="' + v + '" aria-pressed="false">' +
          ill + '<span>' + esc(label) + '</span><span class="psf-n"></span>' + CHECK + '</button>';
      }
      return '<button type="button" class="psf-opt" data-group="' + g + '" data-value="' + v + '" aria-pressed="false">' + esc(label) + '<span class="psf-n"></span>' + CHECK + '</button>';
    }
    var slider = $('psf-slider');
    function renderOptions(){
      F.LIST_GROUPS.forEach(function(g){
        var box = $('psf-opts-' + g), grp = $('psf-group-' + g);
        if (!box || !grp) return;
        box.innerHTML = GROUPS[g].map(function(v){ return optHTML(g, v); }).join('');
        grp.hidden = !GROUPS[g].length;
      });
      var priceGroup = $('psf-group-price');
      if (priceGroup) priceGroup.hidden = !SHOW_PRICE;
      $('psf-presets').innerHTML = PRESETS.map(function(p, i){
        return '<button type="button" data-preset="' + i + '" aria-pressed="false">' + esc(p.label) + '</button>';
      }).join('');
      slider.max = SLIDER_MAX;
      $('psf-range-top').textContent = F.money(SLIDER_MAX);
      $('psf-context').textContent = (COLLECTION.title || '') + (COLLECTION.title ? ' · ' : '') + total + ' ' + nounOf(total);
    }
    renderOptions();
    function anyGroupShown(){ return SHOW_PRICE || F.LIST_GROUPS.some(function(g){ return GROUPS[g].length; }); }

    /* ---- toolbar: FILTERS + count badge, and desktop shortcuts for the groups shown ---- */
    var filterBtn = document.getElementById('tb-filterbtn');
    var badge = document.getElementById('tb-filter-badge');
    /* Idempotent: runs at boot and again when the rest of the feed brings a group the
       first page did not have (a quick button is only added when missing). */
    function ensureToolbar(){
      if (!filterBtn) return;
      filterBtn.setAttribute('aria-haspopup', 'dialog');
      filterBtn.setAttribute('aria-controls', 'psf-dialog');
      filterBtn.hidden = !anyGroupShown();
      var quick = [['price', 'Price', SHOW_PRICE], ['metal', 'Metal', GROUPS.metal.length], ['shape', 'Shape', GROUPS.shape.length]];
      quick.forEach(function(q){
        if (!q[2]) return;
        if (filterBtn.parentNode.querySelector('[data-open-group="' + q[0] + '"]')) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tb-btn tb-quick'; b.setAttribute('data-open-group', q[0]);
        b.setAttribute('aria-haspopup', 'dialog'); b.setAttribute('aria-controls', 'psf-dialog');
        b.innerHTML = esc(q[1]) + ' <span class="psf-chev" aria-hidden="true"></span>';
        filterBtn.parentNode.insertBefore(b, filterBtn);
        b.addEventListener('click', function(e){ openDrawer(e, q[0]); });
      });
    }
    ensureToolbar();

    /* ---- chips ---- */
    function chipsHTML(s){
      return F.entries(s).map(function(e){
        return '<button type="button" class="psf-chip" data-remove="' + e.k + '" data-value="' + esc(e.v) + '" aria-label="Remove ' + esc(e.label) + '">' + esc(e.label) + CROSS + '</button>';
      }).join('');
    }
    var appliedHost = document.getElementById('cg-applied');
    if (appliedHost) appliedHost.classList.add('psf-applied');
    function renderAppliedChips(){
      if (!appliedHost) return;
      var html = chipsHTML(applied);
      appliedHost.innerHTML = html ? html + '<button type="button" class="psf-clear-all" data-remove="*">Clear all</button>' : '';
    }

    /* ---- drawer state ---- */
    function syncInputs(){
      /* A number is written back; empty clears; a malformed entry (NaN) keeps what the
         shopper typed so the error can point at it. */
      ['min', 'max'].forEach(function(k){
        var v = draft[k], el = $('psf-' + k);
        if (v === null) el.value = '';
        else if (isFinite(v)) el.value = String(v);
      });
      slider.value = Math.min(SLIDER_MAX, (draft.max === null || !isFinite(draft.max)) ? SLIDER_MAX : draft.max);
    }
    function updateDraft(){
      var valid = F.validRange(draft);
      var count = valid ? F.countMatches(PRODUCTS, draft) : 0;
      $('psf-price-error').hidden = valid;
      $('psf-min').setAttribute('aria-invalid', String(!valid));
      $('psf-max').setAttribute('aria-invalid', String(!valid));
      var applyBtn = $('psf-apply');
      applyBtn.disabled = !valid;
      applyBtn.innerHTML = 'SHOW ' + count + ' RESULTS ' + ARROW;
      $('psf-count').textContent = valid ? count + ' matching ' + nounOf(count) : 'Check your price range';
      $('psf-clear').disabled = !F.selectedCount(draft);
      $('psf-draft').innerHTML = chipsHTML(draft);
      $('psf-sum-price').textContent = F.hasPrice(draft) ? (valid ? F.priceLabel(draft) : 'Check range') : 'Any price';
      F.LIST_GROUPS.forEach(function(g){
        var el = $('psf-sum-' + g); if (!el) return;
        el.textContent = draft[g].length ? draft[g].length + ' selected' : (g === 'origin' ? 'Either origin' : g === 'stone' ? 'Any color' : 'Any ' + g);
      });
      F.LIST_GROUPS.forEach(function(g){
        if (!GROUPS[g].length) return;
        var counts = valid ? F.optionCounts(PRODUCTS, draft, g, GROUPS[g]) : {};
        GROUPS[g].forEach(function(v){
          var b = psfDialog.querySelector('.psf-opt[data-group="' + g + '"][data-value="' + v + '"]');
          if (!b) return;
          var n = valid ? counts[v] : 0, on = draft[g].indexOf(v) > -1;
          b.setAttribute('aria-pressed', String(on));
          b.disabled = !on && n === 0;
          b.querySelector('.psf-n').textContent = String(n);
          b.setAttribute('aria-label', F.LABELS[g][v] + ', ' + n + ' matching ' + nounOf(n));
        });
      });
      psfDialog.querySelectorAll('[data-preset]').forEach(function(b){
        var p = PRESETS[Number(b.getAttribute('data-preset'))];
        b.setAttribute('aria-pressed', String(!!p && p.min === draft.min && p.max === draft.max));
      });
    }

    /* ---- commit: applied -> shell state -> grid, chips, badge, URL, announcement ---- */
    var liveStatus = document.createElement('span');
    liveStatus.className = 'sr-h'; liveStatus.setAttribute('role', 'status'); liveStatus.setAttribute('aria-live', 'polite');
    document.body.appendChild(liveStatus);
    function toShell(){
      state.shape = new Set(applied.shape); state.metal = new Set(applied.metal);
      state.origin = new Set(applied.origin); state.stone = new Set(applied.stone);
      state.min = applied.min; state.max = applied.max;
    }
    function writeUrl(push){
      if (!window.history || !window.history.replaceState) return;
      var u = new URL(window.location.href);
      F.writeParams(u.searchParams, applied, state.sort);
      var next = u.toString();
      if (next === window.location.href) return;
      if (push) window.history.pushState({psf: 1}, '', next); else window.history.replaceState({psf: 1}, '', next);
    }
    var committing = false;
    function commit(push){
      toShell();
      /* applyFiltersAndSort() calls afterApply(), whose replaceState would land BEFORE
         this pushState and make the push a no-op (the URL already matched). Hold the
         URL write until the commit decides push vs replace. */
      committing = true;
      try { applyFiltersAndSort(); } finally { committing = false; }
      renderAppliedChips();
      writeUrl(push);
      var n = visibleProducts.length;
      liveStatus.textContent = n + ' ' + nounOf(n) + (F.selectedCount(applied) ? ' match your filters.' : '.');
    }
    FILTERS26 = {
      afterApply: function(){ renderAppliedChips(); if (!committing) writeUrl(false); }
    };

    /* ---- open / close ---- */
    function openDrawer(e, group){
      opener = (e && e.currentTarget) || filterBtn;
      draft = F.cloneState(applied);
      syncInputs(); updateDraft();
      psfDialog.showModal();
      document.body.classList.add('psf-open');
      $('psf-close').focus();
      var body = $('psf-body');
      if (group && $('psf-group-' + group) && !$('psf-group-' + group).hidden) {
        $('psf-group-' + group).open = true;
        $('psf-group-' + group).scrollIntoView({block: 'start', behavior: reduced ? 'auto' : 'smooth'});
      } else body.scrollTop = 0;
    }
    function closeDrawer(){
      if (psfDialog.open) psfDialog.close();
      document.body.classList.remove('psf-open');
      if (opener && opener.focus) opener.focus();
    }
    if (filterBtn) filterBtn.addEventListener('click', openDrawer);
    $('psf-close').addEventListener('click', closeDrawer);
    psfDialog.addEventListener('cancel', function(e){ e.preventDefault(); closeDrawer(); });
    psfDialog.addEventListener('close', function(){ document.body.classList.remove('psf-open'); });
    psfDialog.addEventListener('click', function(e){
      if (e.target !== psfDialog) return;
      var r = $('psf-form').getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDrawer();
    });

    /* ---- drawer interactions ---- */
    $('psf-form').addEventListener('click', function(e){
      var b = e.target.closest('[data-group],[data-preset],[data-remove]');
      if (!b || !$('psf-form').contains(b)) return;
      if (b.hasAttribute('data-group')) {
        F.toggle(draft, b.getAttribute('data-group'), b.getAttribute('data-value'));
      } else if (b.hasAttribute('data-preset')) {
        var p = PRESETS[Number(b.getAttribute('data-preset'))];
        if (p) { draft.min = p.min; draft.max = p.max; syncInputs(); }
      } else {
        F.remove(draft, b.getAttribute('data-remove'), b.getAttribute('data-value'));
        syncInputs();
      }
      updateDraft();
    });
    ['min', 'max'].forEach(function(k){
      $('psf-' + k).addEventListener('input', function(){
        draft[k] = F.parseMoney($('psf-' + k).value);
        slider.value = Math.min(SLIDER_MAX, (draft.max === null || !isFinite(draft.max)) ? SLIDER_MAX : draft.max);
        updateDraft();
      });
    });
    slider.addEventListener('input', function(){
      draft.max = Number(slider.value);
      $('psf-max').value = String(draft.max);
      updateDraft();
    });
    $('psf-clear').addEventListener('click', function(){ draft = F.cleanState(); syncInputs(); updateDraft(); });
    $('psf-form').addEventListener('submit', function(e){
      e.preventDefault();
      if (!F.validRange(draft)) return;
      applied = F.cloneState(draft);
      commit(true);
      closeDrawer();
      var gridSec = grid.closest('.grid-sec') || grid;
      var top = gridSec.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) gridSec.scrollIntoView({block: 'start', behavior: reduced ? 'auto' : 'smooth'});
    });

    /* ---- applied chips above the grid, the empty state's reset ---- */
    if (appliedHost) appliedHost.addEventListener('click', function(e){
      var b = e.target.closest('[data-remove]');
      if (!b) return;
      var k = b.getAttribute('data-remove');
      if (k === '*') applied = F.cleanState(); else F.remove(applied, k, b.getAttribute('data-value'));
      commit(true);
    });
    var emptyClear = document.getElementById('cg-empty-clear');
    if (emptyClear) emptyClear.addEventListener('click', function(){ applied = F.cleanState(); commit(true); });

    /* ---- URL: restore on load, follow the back button ---- */
    function fromUrl(){
      var read = F.readParams(new URL(window.location.href).searchParams, {
        shape: GROUPS.shape, metal: GROUPS.metal, origin: GROUPS.origin, stone: GROUPS.stone
      });
      applied = read.state;
      if (!SHOW_PRICE) { applied.min = null; applied.max = null; }
      if (read.sort) state.sort = read.sort;
    }
    window.addEventListener('popstate', function(){ fromUrl(); commit(false); });
    fromUrl();
    toShell();

    /* ---- the feed came up short: say so, and offer a way back ---- */
    function feedNotice(){
      var feedInfo = DATA.feed;
      if (!feedInfo || !feedInfo.failed || !feedInfo.failed.length || $('psf-feed-note')) return;
      var note = document.createElement('div');
      note.id = 'psf-feed-note'; note.className = 'psf-notice'; note.setAttribute('role', 'status');
      note.innerHTML = '<span>Only ' + PRODUCTS.length + ' of ' + feedInfo.expected + ' ' + nounOf(feedInfo.expected) + ' loaded. Filters and counts cover the ' + nounOf(PRODUCTS.length) + ' shown.</span>' +
        '<button type="button">Try again</button>';
      note.querySelector('button').addEventListener('click', function(){ window.location.reload(); });
      grid.parentNode.insertBefore(note, appliedHost && appliedHost.parentNode === grid.parentNode ? appliedHost : grid);
    }
    feedNotice();
    /* Rebuild the option model from the full feed once the rest of it has merged. Skipped
       while the drawer is open (its draft is bound to the controls on screen); the next
       open syncs from `applied` against whatever controls are there. */
    FILTERS26.rebuild = function(){
      if (psfDialog.open) return false;
      computeOptions(); renderOptions(); ensureToolbar(); renderAppliedChips();
      return true;
    };
    FILTERS26.feedNotice = feedNotice;
  })();

  readUrl();
  applyFiltersAndSort();
  if (loadmoreBtn) loadmoreBtn.addEventListener('click', renderPage);


  grid.addEventListener('click', function(e){
    var md = e.target.closest('.mdot');
    if (md) { selectMetal(md.closest('.pcard'), md); return; }
    var wish = e.target.closest('.pcard-wish');
    if (wish) { wishToggle(wish); return; }
    var cmp = e.target.closest('.pcard-compare');
    if (cmp) { toggleCompare(cmp.getAttribute('data-id')); return; }
  });
  /* ---- toolbar: in-stock, sort ---- */
  var tbInstock = document.getElementById('tb-instock');
  if (tbInstock) {
    tbInstock.addEventListener('click', function(){
      state.inStock = !state.inStock;
      tbInstock.classList.toggle('is-on', state.inStock);
      tbInstock.setAttribute('aria-pressed', String(state.inStock));
      applyFiltersAndSort();
    });
    tbInstock.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tbInstock.click(); } });
  }

  var sortWrap = document.getElementById('tb-sortwrap');
  if (sortWrap) {
    var sortBtn = document.getElementById('tb-sortbtn');
    sortBtn.addEventListener('click', function(e){ e.stopPropagation(); var open = sortWrap.classList.toggle('open'); sortBtn.setAttribute('aria-expanded', String(open)); });
    sortWrap.querySelectorAll('.tb-menu button').forEach(function(b){
      b.addEventListener('click', function(){
        sortWrap.querySelectorAll('.tb-menu button').forEach(function(x){ x.classList.remove('sel'); });
        b.classList.add('sel');
        state.sort = b.getAttribute('data-sort');
        document.getElementById('tb-sort-label').textContent = b.textContent;
        sortWrap.classList.remove('open');
        applyFiltersAndSort();
      });
    });
    document.addEventListener('click', function(){ sortWrap.classList.remove('open'); });
    /* a page that starts on a non-default sort (search with ?sort_by=, or a restored
       ?f_sort=) shows it selected */
    if (state.sort !== 'rank') {
      sortWrap.querySelectorAll('.tb-menu button').forEach(function(x){
        var on = x.getAttribute('data-sort') === state.sort;
        x.classList.toggle('sel', on);
        if (on) { var lab = document.getElementById('tb-sort-label'); if (lab) lab.textContent = x.textContent; }
      });
    }
  }

  /* ---- filter drawer ---- */
  var drawer = document.getElementById('cf-drawer');
  function closeDrawer(){ if (drawer) { drawer.classList.remove('open'); document.documentElement.style.overflow = ''; } }
  if (drawer) {
    var openDrawer = function(){ drawer.classList.add('open'); document.documentElement.style.overflow = 'hidden'; };
    document.getElementById('tb-filterbtn').addEventListener('click', openDrawer);
    document.getElementById('cf-close').addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function(e){ if (e.target === drawer) closeDrawer(); });

    var previewCount = function(){
      return PRODUCTS.filter(matchesFilters).length;
    };
    var applyBtn = document.getElementById('cf-apply');
    var updateApplyLabel = function(){ if (applyBtn) applyBtn.textContent = 'Show ' + previewCount() + ' Results'; };
    var bindChips = function(sel, attr, set){
      document.querySelectorAll(sel + ' .fchip').forEach(function(c){
        c.addEventListener('click', function(){
          var v = c.getAttribute(attr);
          c.classList.toggle('on');
          if (set.has(v)) set.delete(v); else set.add(v);
          updateApplyLabel();
        });
      });
    };
    bindChips('#cf-shape', 'data-shape', state.shape);
    bindChips('#cf-metal', 'data-metal', state.metal);
    bindChips('#cf-price', 'data-price', state.price);
    bindChips('#cf-stone', 'data-stone', state.stone);
    bindChips('#cf-origin', 'data-origin', state.origin);
    bindChips('#cf-category', 'data-category', state.category);
    bindChips('#cf-carat', 'data-carat', state.carat);
    document.getElementById('cf-clear').addEventListener('click', function(){
      document.querySelectorAll('#cf-drawer .fchip.on').forEach(function(c){ c.classList.remove('on'); });
      FILTER_KEYS.forEach(function(k){ state[k].clear(); });
      updateApplyLabel();
    });
    if (applyBtn) applyBtn.addEventListener('click', function(){ closeDrawer(); applyFiltersAndSort(); });
    var emptyClear = document.getElementById('cg-empty-clear');
    if (emptyClear) emptyClear.addEventListener('click', function(){
      document.getElementById('cf-clear').click();
      applyFiltersAndSort();
    });
    updateApplyLabel();
  }
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') { closeDrawer(); closeCompareModal(); } });


}
/* The products snippet hands the shell a promise for the FIRST feed page (2026-09-09):
   boot the moment it lands, and let the rest of the collection merge in behind it.
   Without a pending feed (the _ds mockups, the search page) boot runs at once. */
(function(){
  var pc = window.PS_COLLECTION;
  if (pc && pc.pending && typeof pc.pending.then === 'function') pc.pending.then(psCol26Boot, psCol26Boot);
  else psCol26Boot();

  /* ---- Affirm monthly line on cards (owner 2026-10-20, recording #277, option A) ----
     The number is Affirm's, from the promos endpoint its own widget calls (policy D52:
     nothing is computed here). One call per price, cached, only for cards near the screen,
     at most 4 in flight. Affirm lends in US dollars, so other currencies hide the line. */
  (function () {
    var root = document.documentElement;
    if ((window.PSMoney && PSMoney.iso !== 'USD') || !window.fetch || !window.IntersectionObserver) { root.classList.add('ps-no-pmo'); return; }
    var CACHE = {}, WAIT = {}, queue = [], inflight = 0;
    function paint(el, txt) { if (txt) { el.innerHTML = 'or <b>' + txt + '</b> with <span class="pmo-aff">Affirm</span>'; el.classList.add('is-on'); } }
    function pump() {
      while (inflight < 4 && queue.length) {
        (function (amt) {
          inflight++;
          fetch('https://www.affirm.com/api/promos/v2/9NRTW2HQ81H4AWAR?field=ala&locale=en_US&amount=' + amt, { credentials: 'omit' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (d) {
              var t = d && d.promo && d.promo.ala, m = t && String(t).replace(/<[^>]*>/g, '').match(/\$[\d,]+(?:\.\d{2})?\s*\/\s*mo/);
              CACHE[amt] = m ? m[0].replace(/\s+/g, '') : '';
            })
            .catch(function () { CACHE[amt] = ''; })
            .then(function () { inflight--; (WAIT[amt] || []).forEach(function (el) { paint(el, CACHE[amt]); }); delete WAIT[amt]; pump(); });
        })(queue.shift());
      }
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, amt = el.getAttribute('data-amt');
        if (amt in CACHE) return paint(el, CACHE[amt]);
        if (WAIT[amt]) return WAIT[amt].push(el);
        WAIT[amt] = [el]; queue.push(amt); pump();
      });
    }, { rootMargin: '300px 0px' });
    function scan() { document.querySelectorAll('.pmo[data-amt]:not([data-pmo])').forEach(function (el) { el.setAttribute('data-pmo', '1'); io.observe(el); }); }
    scan();
    var t = null;
    new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; scan(); }, 120); })
      .observe(document.body, { childList: true, subtree: true });
  })();
})();
